const translations = {
  de: {
    // Navigation
    nav_for_drivers: "Für Fahrer",
    nav_for_companies: "Für Unternehmen",
    nav_driver_dashboard: "Fahrer-Dashboard",
    nav_my_transfers: "Meine Transfers",
    nav_admin: "Admin",
    nav_login: "Anmelden",
    nav_logout: "Abmelden",
    
    // Auth Modal
    auth_welcome: "Willkommen zurück",
    auth_register_title: "Konto erstellen",
    auth_login_subtitle: "Melden Sie sich an, um Ihre Transfers zu verwalten",
    auth_register_subtitle: "Erstellen Sie ein Konto für Ihren Transfer",
    auth_name: "Vollständiger Name",
    auth_email: "E-Mail-Adresse",
    auth_password: "Passwort",
    auth_phone: "Telefonnummer",
    auth_login_btn: "Anmelden",
    auth_register_btn: "Konto erstellen",
    auth_switch_to_register: "Kein Konto? Registrieren",
    auth_switch_to_login: "Bereits ein Konto? Anmelden",
    auth_fill_all: "Bitte füllen Sie alle Pflichtfelder aus",
    auth_invalid: "Ungültige E-Mail oder Passwort",
    
    // Landing Page
    landing_hero_title: "Flughafentransfers zum besten Preis",
    landing_hero_subtitle: "Vergleichen Sie Angebote von verifizierten Fahrern und buchen Sie Ihren Transfer in wenigen Minuten",
    landing_from: "Von wo?",
    landing_to: "Wohin?",
    landing_search: "Transfer suchen",
    landing_how_it_works: "So funktioniert's",
    landing_step1_title: "Route eingeben",
    landing_step1_desc: "Geben Sie Abholort und Zielort ein",
    landing_step2_title: "Angebote vergleichen",
    landing_step2_desc: "Erhalten Sie Angebote von Fahrern",
    landing_step3_title: "Buchen & bezahlen",
    landing_step3_desc: "Wählen Sie das beste Angebot",
    landing_why_title: "Warum 366Transfer?",
    landing_get_app_title: "Hol Dir die App",
    landing_get_app_desc: "Buchen Sie schneller, verwalten Sie Ihre Transfers und erhalten Sie Push-Benachrichtigungen direkt auf Ihr Handy.",
    landing_get_app_hint: "Scannen Sie den QR-Code mit Ihrer Handy-Kamera, um die App direkt zu öffnen.",
    landing_best_price: "Bester Preis",
    landing_best_price_desc: "Vergleichen Sie Angebote und sparen Sie",
    landing_safe: "Sicher & Zuverlässig",
    landing_safe_desc: "Verifizierte Fahrer und Fahrzeuge",
    landing_support: "24/7 Support",
    landing_support_desc: "Wir sind immer für Sie da",
    landing_driver_cta_title: "Werden Sie Fahrer bei 366Transfer",
    landing_driver_cta_desc: "Verdienen Sie Geld mit Flughafentransfers",
    landing_driver_cta_btn: "Als Fahrer registrieren",
    landing_vehicles: "Unsere Fahrzeugklassen",
    
    // Booking
    booking_title: "Transfer buchen",
    booking_vehicle: "Fahrzeugklasse",
    booking_date: "Datum",
    booking_time: "Uhrzeit",
    booking_flight: "Flugnummer",
    booking_passengers: "Passagiere",
    booking_adults: "Erwachsene",
    booking_children: "Kinder",
    booking_child_seats: "Kindersitze",
    booking_luggage: "Gepäck",
    booking_comments: "Anmerkungen",
    booking_submit: "Transfer anfragen",
    booking_login_required: "Bitte melden Sie sich an, um einen Transfer zu buchen",
    
    // Customer Dashboard
    dashboard_title: "Meine Transfers",
    dashboard_subtitle: "Verwalten Sie Ihre Buchungen und vergleichen Sie Angebote",
    dashboard_total: "Anfragen gesamt",
    dashboard_with_offers: "Mit Angeboten",
    dashboard_booked: "Gebucht",
    dashboard_login_required: "Anmeldung erforderlich",
    dashboard_login_desc: "Bitte melden Sie sich an, um Ihre Transfers zu sehen",
    dashboard_login_btn: "Zur Anmeldung",
    dashboard_no_transfers: "Noch keine Transfers",
    dashboard_no_transfers_desc: "Buchen Sie Ihren ersten Transfer auf der Startseite",
    dashboard_offers: "Angebote",
    dashboard_offers_available: "Angebote verfügbar",
    dashboard_booked_driver: "Gebuchter Fahrer",
    dashboard_trips: "Fahrten",
    dashboard_offer_anonymous_driver: "Verifizierter Fahrer",
    dashboard_offer_privacy_hint: "Vollständige Kontaktdaten (Name, E-Mail, Telefon) werden nach Zahlungsbestätigung freigeschaltet.",
    trust_ssl: "SSL-verschlüsselt",
    trust_verified: "Verifizierte Fahrer",
    trust_escrow: "Escrow-Schutz",
    trust_cancel: "24h Storno",
    trust_price_details: "Preisdetails anzeigen",
    trust_price_driver: "Fahrer-Angebot",
    trust_price_fee: "366transfer Servicegebühr (15%)",
    trust_price_total: "Gesamt",
    trust_escrow_note: "Fahrer wird erst nach Ihrer sicheren Ankunft bezahlt.",
    trust_cancellation_full: "Kostenlose Stornierung bis 24h vor Abholung – 100% Geld-zurück-Garantie.",
    trust_escrow_payment: "Sichere Zahlung an 366transfer. Ihr Fahrer wird von uns bezahlt nach Ihrer sicheren Ankunft.",
    trust_exit_title: "Noch Fragen zu Ihrer Buchung?",
    trust_exit_subtitle: "Wir helfen Ihnen persönlich weiter – ohne Kaufdruck.",
    trust_exit_whatsapp: "WhatsApp-Support kontaktieren",
    trust_exit_back: "Zurück zum Angebot",
    dashboard_pay_card: "Karte",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "Bezahlt & Gebucht",
    dashboard_paid: "Bezahlt",
    dashboard_status_open: "Offen",
    dashboard_status_bidding: "Angebote verfügbar",
    dashboard_status_booked: "Gebucht",
    dashboard_status_cancelled: "Storniert",
    dashboard_completed: "Abgeschlossen",
    
    // Rating
    rating_title: "Fahrerbewertung",
    rating_punctuality: "Pünktlichkeit",
    rating_cleanliness: "Sauberkeit",
    rating_friendliness: "Freundlichkeit",
    rating_driving_style: "Fahrstil",
    rating_comment: "Kommentar (optional)",
    rating_submit: "Bewertung abschicken",
    rating_thank_you: "Vielen Dank!",
    rating_submitted: "Ihre Bewertung wurde erfolgreich übermittelt.",
    rating_overall: "Gesamtbewertung",
    rating_reviews: "Kundenbewertungen",
    
    // Admin
    admin_title: "Admin Dashboard",
    admin_overview: "Übersicht",
    admin_pending: "Freischaltung",
    admin_drivers: "Fahrer",
    admin_companies: "Unternehmen",
    admin_transfers: "Transfers",
    admin_payments: "Zahlungen",
    admin_users: "Benutzer",
    admin_approve: "Genehmigen",
    admin_reject: "Ablehnen",
    admin_block: "Sperren",
    admin_unblock: "Entsperren",
    admin_documents: "Dokumente",
    admin_export: "Exportieren",
    admin_revenue: "Umsatz",
    admin_active: "Aktiv",
    admin_blocked: "Gesperrt",
    admin_search: "Suchen...",
    
    // Public Profile
    profile_driver: "Fahrerprofil",
    profile_company: "Unternehmensprofil",
    profile_member_since: "Mitglied seit",
    profile_trips: "Fahrten",
    profile_fleet: "Fahrzeugflotte",
    
    // Payment
    payment_processing: "Zahlung wird verarbeitet...",
    payment_success: "Zahlung erfolgreich! Ihre Buchung ist bestätigt.",
    payment_cancelled: "Zahlung abgebrochen. Sie können es erneut versuchen.",
    payment_error: "Zahlungsstatus konnte nicht überprüft werden.",
    payment_paypal_processing: "PayPal-Zahlung wird verarbeitet...",
    payment_paypal_success: "PayPal-Zahlung erfolgreich! Ihre Buchung ist bestätigt.",
    payment_paypal_error: "Fehler bei der PayPal-Zahlungsbestätigung.",
    
    // Driver Dashboard
    driver_title: "Fahrer-Portal",
    driver_new: "Neu",
    driver_my_offers: "Meine Angebote",
    driver_offer_price: "Angebot abgeben",
    driver_requests: "neue Anfragen",
    driver_active_offers: "aktive Angebote",
    driver_bookings: "Buchungen",
    driver_search: "Suche...",
    
    // Common
    common_back: "Zurück",
    common_home: "Startseite",
    common_loading: "Laden...",
    common_error: "Fehler",
    common_save: "Speichern",
    common_cancel: "Abbrechen",
    common_delete: "Löschen",
    common_edit: "Bearbeiten",
    common_add: "Hinzufügen",
    common_close: "Schließen",
    common_confirm: "Bestätigen",
    common_persons: "Pers.",
    common_km: "km",
    common_min: "Min.",
    common_about: "Über uns",
    common_contact: "Kontakt",
    common_language: "Sprache",
    
    // Company
    company_title: "Unternehmen registrieren",
    company_subtitle: "Fleet Management für Transportunternehmen",
    company_name: "Firmenname",
    company_contact: "Ansprechpartner",
    company_phone: "Telefon",
    company_region: "Region",
    company_languages: "Sprachen",
    company_step_company: "Unternehmen",
    company_step_vehicles: "Fahrzeuge",
    company_step_drivers: "Fahrer",
    company_next_vehicles: "Weiter: Fahrzeuge",
    company_next_drivers: "Weiter: Fahrer",
    company_submit: "Unternehmen registrieren",
    company_add_vehicle: "Fahrzeug hinzufügen",
    company_add_driver: "Fahrer hinzufügen",
    company_success: "Unternehmen registriert!",
    company_success_desc: "Ihr Unternehmen wird von unserem Team geprüft.",
    company_summary: "Zusammenfassung",
    company_vehicles_count: "Fahrzeuge",
    company_drivers_count: "Fahrer",
    
    // Footer
    footer_rights: "Alle Rechte vorbehalten",
    footer_imprint: "Impressum",
    footer_privacy: "Datenschutz",
    footer_terms: "AGB",
    
    // Extra Landing
    landing_bullet1: "Premium-Fahrzeuge zu Economy-Preisen",
    landing_bullet2: "Vergleichen Sie Fahrerangebote sofort",
    landing_bullet3: "Sicher bezahlen mit Kreditkarte, PayPal & mehr",
    landing_tab_transfer: "Transfer",
    landing_tab_hourly: "Stündlich",
    landing_continue: "Weiter",
    landing_vehicles_subtitle: "Von Economy bis Luxus - finden Sie die perfekte Fahrt",
    landing_easy_payment: "Einfache Zahlung",
    landing_easy_payment_desc: "Visa, Mastercard, PayPal, Twint & mehr",
    landing_hourly_rental: "Stündliche Miete",
    
    // Driver Dashboard extra
    driver_portal: "Fahrer-Portal",
    driver_tab_new: "Neu",
    driver_tab_vehicles: "Fahrzeuge",
    driver_tab_profile: "Mein Profil",
    driver_tab_with_offers: "Mit meinen Angeboten",
    driver_tab_bookings: "Buchungen",
    driver_sort_created: "Erstellt am",
    driver_filter: "Filter",
    driver_search_placeholder: "Suche...",
    driver_col_id: "#",
    driver_col_ride_date: "Fahrdatum",
    driver_col_type: "Typ",
    driver_col_distance: "Entfernung",
    driver_col_from: "Von",
    driver_col_to: "Nach",
    driver_col_passengers: "Passagiere",
    driver_col_transport: "Transport",
    driver_col_your_offer: "Ihr Angebot",
    driver_offered: "Angeboten",
    driver_offer_price_btn: "Preis anbieten",
    driver_no_requests: "Keine Anfragen verfügbar",
    driver_no_bookings: "Noch keine Buchungen",
    driver_new_requests: "neue Anfragen",
    driver_active_offers_count: "aktive Angebote",
    driver_bookings_count: "Buchungen",
    driver_created: "erstellt",
    driver_return: "Rückfahrt",
    driver_tbd: "offen",
    driver_submit_offer: "Preis anbieten",
    driver_make_offer_title: "Angebot abgeben",
    driver_make_offer_desc: "Geben Sie Ihren Preis für diese Fahrt an",
    driver_your_price: "Ihr Preis (EUR)",
    driver_notes_label: "Notizen (optional)",
    driver_notes_placeholder: "z.B. Flasche Wasser inklusive, Kindersitz verfügbar...",
    driver_price_placeholder: "z.B. 45",
    driver_price_suggestion: "Preisvorschlag",
    driver_price_recommended: "empfohlen",
    driver_price_range: "Bereich",
    driver_cancel: "Abbrechen",
    driver_login_required: "Anmeldung erforderlich",
    driver_login_desc: "Bitte melden Sie sich an, um auf das Fahrer-Dashboard zuzugreifen.",
    driver_login_btn: "Zur Anmeldung",
    driver_no_profile: "Kein Fahrerprofil",
    driver_no_profile_desc: "Sie müssen sich zuerst als Fahrer registrieren.",
    driver_register_btn: "Als Fahrer registrieren",
    driver_pending_title: "Bewerbung in Prüfung",
    driver_pending_desc: "Ihre Fahrerbewerbung wird geprüft. Bitte haben Sie Geduld.",
    driver_rejected_title: "Bewerbung abgelehnt",
    driver_rejected_desc: "Leider wurde Ihre Bewerbung abgelehnt.",
    driver_complete_btn: "Abgeschlossen",
    driver_complete_confirm: "Möchten Sie diese Fahrt als abgeschlossen markieren? Der Kunde erhält eine E-Mail zur Bewertung.",
    driver_complete_success: "Fahrt als abgeschlossen markiert! Der Kunde wurde per E-Mail zur Bewertung eingeladen.",
    driver_offer_success: "Angebot erfolgreich gesendet!",
    driver_offer_invalid_price: "Bitte geben Sie einen gültigen Preis ein",
    driver_status_completed: "Abgeschlossen",
    driver_status_booked: "Gebucht",
    driver_docs_missing_alert: "Bitte laden Sie alle Pflichtdokumente hoch, bevor Sie fortfahren.",
    driver_docs_title: "Dokumente hochladen",
    driver_docs_subtitle: "Bitte laden Sie alle erforderlichen Dokumente hoch",
    driver_docs_selfie: "Selfie mit Führerschein",
    driver_docs_registration: "Fahrzeugzulassung",
    driver_docs_vehicle_photo: "Fahrzeugfoto",
    driver_docs_insurance: "Versicherungsnachweis",
    driver_docs_license: "Transportlizenz (optional)",
    driver_docs_required: "Pflicht",
    driver_docs_optional: "Optional",
    driver_docs_uploaded: "Hochgeladen",
    driver_docs_camera: "Kamera",
    driver_docs_upload: "Hochladen",
    driver_docs_complete_btn: "Fertig & Weiter",
    driver_docs_btn: "Dokumente",
    driver_docs_incomplete: "Dokumente unvollständig",
    driver_docs_all_complete: "Alle Dokumente vorhanden",
    driver_terms_accept_text: "Ich akzeptiere die",
    driver_terms_link: "AGB für Fahrer",
    driver_terms_binding_text: "Mein Angebot ist verbindlich. Ich bin verpflichtet, den Transfer zum vereinbarten Zeitpunkt und Preis durchzuführen, sobald der Kunde bucht und bezahlt.",
    
    // Profile Management
    profile_settings: "Profil-Einstellungen",
    profile_edit: "Profil bearbeiten",
    profile_change_password: "Passwort ändern",
    profile_logout: "Abmelden",
    profile_name: "Name",
    profile_email: "E-Mail",
    profile_phone: "Telefon",
    profile_save: "Speichern",
    profile_cancel: "Abbrechen",
    profile_current_password: "Aktuelles Passwort",
    profile_new_password: "Neues Passwort",
    profile_confirm_password: "Passwort bestätigen",
    profile_password_mismatch: "Passwörter stimmen nicht überein",
    profile_password_changed: "Passwort erfolgreich geändert",
    profile_updated: "Profil erfolgreich aktualisiert",
    profile_reapproval_warning: "Wenn Sie Name, E-Mail oder Fahrzeugdaten ändern, muss Ihr Konto erneut freigeschaltet werden.",
    profile_reapproval_triggered: "Ihr Konto muss erneut vom Admin freigeschaltet werden.",
    profile_vehicle_info: "Fahrzeugdaten",
    profile_vehicle_make: "Hersteller",
    profile_vehicle_model: "Modell",
    profile_vehicle_year: "Baujahr",
    profile_vehicle_color: "Farbe",
    profile_vehicle_plate: "Kennzeichen",
    profile_vehicle_type: "Fahrzeugtyp",
    profile_vehicle_passengers: "Passagiere",
    profile_vehicle_luggage: "Gepäck",
  },
  
  en: {
    nav_for_drivers: "For Drivers",
    nav_for_companies: "For Companies",
    nav_driver_dashboard: "Driver Dashboard",
    nav_my_transfers: "My Transfers",
    nav_admin: "Admin",
    nav_login: "Login",
    nav_logout: "Logout",
    
    auth_welcome: "Welcome back",
    auth_register_title: "Create Account",
    auth_login_subtitle: "Sign in to manage your transfers",
    auth_register_subtitle: "Create an account for your transfer",
    auth_name: "Full Name",
    auth_email: "Email Address",
    auth_password: "Password",
    auth_phone: "Phone Number",
    auth_login_btn: "Sign In",
    auth_register_btn: "Create Account",
    auth_switch_to_register: "No account? Register",
    auth_switch_to_login: "Already have an account? Sign In",
    auth_fill_all: "Please fill in all required fields",
    auth_invalid: "Invalid email or password",
    
    landing_hero_title: "Airport Transfers at the Best Price",
    landing_hero_subtitle: "Compare offers from verified drivers and book your transfer in minutes",
    landing_from: "From where?",
    landing_to: "Where to?",
    landing_search: "Search Transfers",
    landing_how_it_works: "How It Works",
    landing_step1_title: "Enter Route",
    landing_step1_desc: "Enter pickup and drop-off location",
    landing_step2_title: "Compare Offers",
    landing_step2_desc: "Receive offers from drivers",
    landing_step3_title: "Book & Pay",
    landing_step3_desc: "Choose the best offer",
    landing_why_title: "Why 366Transfer?",
    landing_get_app_title: "Get The App",
    landing_get_app_desc: "Book faster, manage your transfers and receive push notifications right on your phone.",
    landing_get_app_hint: "Scan the QR code with your phone's camera to open the app directly.",
    landing_best_price: "Best Price",
    landing_best_price_desc: "Compare offers and save money",
    landing_safe: "Safe & Reliable",
    landing_safe_desc: "Verified drivers and vehicles",
    landing_support: "24/7 Support",
    landing_support_desc: "We are always here for you",
    landing_driver_cta_title: "Become a Driver at 366Transfer",
    landing_driver_cta_desc: "Earn money with airport transfers",
    landing_driver_cta_btn: "Register as Driver",
    landing_vehicles: "Our Vehicle Classes",
    
    booking_title: "Book Transfer",
    booking_vehicle: "Vehicle Class",
    booking_date: "Date",
    booking_time: "Time",
    booking_flight: "Flight Number",
    booking_passengers: "Passengers",
    booking_adults: "Adults",
    booking_children: "Children",
    booking_child_seats: "Child Seats",
    booking_luggage: "Luggage",
    booking_comments: "Comments",
    booking_submit: "Request Transfer",
    booking_login_required: "Please sign in to book a transfer",
    
    dashboard_title: "My Transfers",
    dashboard_subtitle: "Manage your bookings and compare offers",
    dashboard_total: "Total Requests",
    dashboard_with_offers: "With Offers",
    dashboard_booked: "Booked",
    dashboard_login_required: "Login Required",
    dashboard_login_desc: "Please sign in to view your transfers",
    dashboard_login_btn: "Sign In",
    dashboard_no_transfers: "No Transfers Yet",
    dashboard_no_transfers_desc: "Book your first transfer on the homepage",
    dashboard_offers: "Offers",
    dashboard_offers_available: "Offers available",
    dashboard_booked_driver: "Booked Driver",
    dashboard_trips: "trips",
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "Card",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "Paid & Booked",
    dashboard_paid: "Paid",
    dashboard_status_open: "Open",
    dashboard_status_bidding: "Offers available",
    dashboard_status_booked: "Booked",
    dashboard_status_cancelled: "Cancelled",
    dashboard_completed: "Completed",
    
    rating_title: "Driver Rating",
    rating_punctuality: "Punctuality",
    rating_cleanliness: "Cleanliness",
    rating_friendliness: "Friendliness",
    rating_driving_style: "Driving Style",
    rating_comment: "Comment (optional)",
    rating_submit: "Submit Rating",
    rating_thank_you: "Thank You!",
    rating_submitted: "Your rating has been submitted successfully.",
    rating_overall: "Overall Rating",
    rating_reviews: "Customer Reviews",
    
    admin_title: "Admin Dashboard",
    admin_overview: "Overview",
    admin_pending: "Approvals",
    admin_drivers: "Drivers",
    admin_companies: "Companies",
    admin_transfers: "Transfers",
    admin_payments: "Payments",
    admin_users: "Users",
    admin_approve: "Approve",
    admin_reject: "Reject",
    admin_block: "Block",
    admin_unblock: "Unblock",
    admin_documents: "Documents",
    admin_export: "Export",
    admin_revenue: "Revenue",
    admin_active: "Active",
    admin_blocked: "Blocked",
    admin_search: "Search...",
    
    profile_driver: "Driver Profile",
    profile_company: "Company Profile",
    profile_member_since: "Member since",
    profile_trips: "trips",
    profile_fleet: "Vehicle Fleet",
    
    payment_processing: "Payment is being processed...",
    payment_success: "Payment successful! Your booking is confirmed.",
    payment_cancelled: "Payment cancelled. You can try again.",
    payment_error: "Could not verify payment status.",
    payment_paypal_processing: "PayPal payment is being processed...",
    payment_paypal_success: "PayPal payment successful! Your booking is confirmed.",
    payment_paypal_error: "Error with PayPal payment confirmation.",
    
    driver_title: "Driver Portal",
    driver_new: "New",
    driver_my_offers: "My Offers",
    driver_offer_price: "Make Offer",
    driver_requests: "new requests",
    driver_active_offers: "active offers",
    driver_bookings: "bookings",
    driver_search: "Search...",
    
    common_back: "Back",
    common_home: "Home",
    common_loading: "Loading...",
    common_error: "Error",
    common_save: "Save",
    common_cancel: "Cancel",
    common_delete: "Delete",
    common_edit: "Edit",
    common_add: "Add",
    common_close: "Close",
    common_confirm: "Confirm",
    common_persons: "pers.",
    common_km: "km",
    common_min: "min",
    common_about: "About Us",
    common_contact: "Contact",
    common_language: "Language",
    
    company_title: "Register Company",
    company_subtitle: "Fleet Management for transport companies",
    company_name: "Company Name",
    company_contact: "Contact Person",
    company_phone: "Phone",
    company_region: "Region",
    company_languages: "Languages",
    company_step_company: "Company",
    company_step_vehicles: "Vehicles",
    company_step_drivers: "Drivers",
    company_next_vehicles: "Next: Vehicles",
    company_next_drivers: "Next: Drivers",
    company_submit: "Register Company",
    company_add_vehicle: "Add Vehicle",
    company_add_driver: "Add Driver",
    company_success: "Company Registered!",
    company_success_desc: "Your company will be reviewed by our team.",
    company_summary: "Summary",
    company_vehicles_count: "Vehicles",
    company_drivers_count: "Drivers",
    
    footer_rights: "All rights reserved",
    footer_imprint: "Imprint",
    footer_privacy: "Privacy",
    footer_terms: "Terms",
    
    landing_bullet1: "Premium vehicles at economy prices",
    landing_bullet2: "Compare driver offers instantly",
    landing_bullet3: "Pay securely with credit card, PayPal & more",
    landing_tab_transfer: "Transfer",
    landing_tab_hourly: "Hourly",
    landing_continue: "Continue",
    landing_vehicles_subtitle: "From Economy to Luxury - find the perfect ride",
    landing_easy_payment: "Easy Payment",
    landing_easy_payment_desc: "Visa, Mastercard, PayPal, Twint & more",
    landing_hourly_rental: "Hourly Rental",

    // Driver Dashboard extra
    driver_portal: "Driver Portal",
    driver_tab_new: "New",
    driver_tab_vehicles: "Vehicles",
    driver_tab_profile: "My Profile",
    driver_tab_with_offers: "With my offers",
    driver_tab_bookings: "Bookings",
    driver_sort_created: "Created at",
    driver_filter: "Filter",
    driver_search_placeholder: "Search...",
    driver_col_id: "#",
    driver_col_ride_date: "Ride date",
    driver_col_type: "Type",
    driver_col_distance: "Distance",
    driver_col_from: "From",
    driver_col_to: "To",
    driver_col_passengers: "Passengers",
    driver_col_transport: "Transport",
    driver_col_your_offer: "Your offer",
    driver_offered: "Offered",
    driver_offer_price_btn: "Offer price",
    driver_no_requests: "No requests available",
    driver_no_bookings: "No bookings yet",
    driver_new_requests: "new requests",
    driver_active_offers_count: "active offers",
    driver_bookings_count: "bookings",
    driver_created: "created",
    driver_return: "Return",
    driver_tbd: "TBD",
    driver_submit_offer: "Offer price",
    driver_make_offer_title: "Make an Offer",
    driver_make_offer_desc: "Set your price for this ride",
    driver_your_price: "Your Price (EUR)",
    driver_notes_label: "Notes (optional)",
    driver_notes_placeholder: "e.g. Bottle of water included, child seat available...",
    driver_price_placeholder: "e.g. 45",
    driver_price_suggestion: "Price Suggestion",
    driver_price_recommended: "recommended",
    driver_price_range: "Range",
    driver_cancel: "Cancel",
    driver_login_required: "Login Required",
    driver_login_desc: "Please sign in to access the driver dashboard.",
    driver_login_btn: "Sign In",
    driver_no_profile: "No Driver Profile",
    driver_no_profile_desc: "You need to register as a driver first.",
    driver_register_btn: "Register as Driver",
    driver_pending_title: "Application Under Review",
    driver_pending_desc: "Your driver application is being reviewed. Please be patient.",
    driver_rejected_title: "Application Rejected",
    driver_rejected_desc: "Unfortunately, your application was rejected.",
    driver_complete_btn: "Completed",
    driver_complete_confirm: "Mark this trip as completed? The customer will receive a rating email.",
    driver_complete_success: "Trip marked as completed! Customer was invited to rate via email.",
    driver_offer_success: "Offer sent successfully!",
    driver_offer_invalid_price: "Please enter a valid price",
    driver_status_completed: "Completed",
    driver_status_booked: "Booked",
    driver_docs_missing_alert: "Please upload all required documents before proceeding.",
    driver_docs_title: "Upload Documents",
    driver_docs_subtitle: "Please upload all required documents",
    driver_docs_selfie: "Selfie with License",
    driver_docs_registration: "Vehicle Registration",
    driver_docs_vehicle_photo: "Vehicle Photo",
    driver_docs_insurance: "Insurance Certificate",
    driver_docs_license: "Transport License (optional)",
    driver_docs_required: "Required",
    driver_docs_optional: "Optional",
    driver_docs_uploaded: "Uploaded",
    driver_docs_camera: "Camera",
    driver_docs_upload: "Upload",
    driver_docs_complete_btn: "Done & Continue",
    driver_docs_btn: "Documents",
    driver_docs_incomplete: "Documents incomplete",
    driver_docs_all_complete: "All documents uploaded",
    driver_terms_accept_text: "I accept the",
    driver_terms_link: "Driver Terms & Conditions",
    driver_terms_binding_text: "My offer is binding. I am obligated to perform the transfer at the agreed time and price once the customer books and pays.",
    
    // Profile Management
    profile_settings: "Profile Settings",
    profile_edit: "Edit Profile",
    profile_change_password: "Change Password",
    profile_logout: "Logout",
    profile_name: "Name",
    profile_email: "Email",
    profile_phone: "Phone",
    profile_save: "Save",
    profile_cancel: "Cancel",
    profile_current_password: "Current Password",
    profile_new_password: "New Password",
    profile_confirm_password: "Confirm Password",
    profile_password_mismatch: "Passwords do not match",
    profile_password_changed: "Password changed successfully",
    profile_updated: "Profile updated successfully",
    profile_reapproval_warning: "Changing name, email, or vehicle data requires re-approval of your account.",
    profile_reapproval_triggered: "Your account needs to be re-approved by admin.",
    profile_vehicle_info: "Vehicle Information",
    profile_vehicle_make: "Make",
    profile_vehicle_model: "Model",
    profile_vehicle_year: "Year",
    profile_vehicle_color: "Color",
    profile_vehicle_plate: "Plate Number",
    profile_vehicle_type: "Vehicle Type",
    profile_vehicle_passengers: "Passengers",
    profile_vehicle_luggage: "Luggage",
  },
  
  ar: {
    nav_for_drivers: "للسائقين",
    nav_for_companies: "للشركات",
    nav_driver_dashboard: "لوحة السائق",
    nav_my_transfers: "رحلاتي",
    nav_admin: "المدير",
    nav_login: "تسجيل الدخول",
    nav_logout: "تسجيل الخروج",
    
    auth_welcome: "مرحباً بعودتك",
    auth_register_title: "إنشاء حساب",
    auth_login_subtitle: "سجل دخولك لإدارة رحلاتك",
    auth_register_subtitle: "أنشئ حساباً لحجز رحلتك",
    auth_name: "الاسم الكامل",
    auth_email: "البريد الإلكتروني",
    auth_password: "كلمة المرور",
    auth_phone: "رقم الهاتف",
    auth_login_btn: "تسجيل الدخول",
    auth_register_btn: "إنشاء حساب",
    auth_switch_to_register: "ليس لديك حساب؟ سجل الآن",
    auth_switch_to_login: "لديك حساب؟ سجل دخولك",
    auth_fill_all: "يرجى ملء جميع الحقول المطلوبة",
    auth_invalid: "بريد إلكتروني أو كلمة مرور غير صحيحة",
    
    landing_hero_title: "توصيل المطار بأفضل الأسعار",
    landing_hero_subtitle: "قارن عروض السائقين المعتمدين واحجز رحلتك في دقائق",
    landing_from: "من أين؟",
    landing_to: "إلى أين؟",
    landing_search: "البحث عن رحلة",
    landing_how_it_works: "كيف يعمل",
    landing_step1_title: "أدخل المسار",
    landing_step1_desc: "أدخل نقطة الانطلاق والوصول",
    landing_step2_title: "قارن العروض",
    landing_step2_desc: "احصل على عروض من السائقين",
    landing_step3_title: "احجز وادفع",
    landing_step3_desc: "اختر أفضل عرض",
    landing_why_title: "لماذا 366Transfer؟",
    landing_get_app_title: "احصل على التطبيق",
    landing_get_app_desc: "احجز بشكل أسرع، أدر نقل الركاب الخاص بك واستلم الإشعارات مباشرة على هاتفك.",
    landing_get_app_hint: "امسح رمز QR بكاميرا هاتفك لفتح التطبيق مباشرة.",
    landing_best_price: "أفضل سعر",
    landing_best_price_desc: "قارن العروض ووفر المال",
    landing_safe: "آمن وموثوق",
    landing_safe_desc: "سائقون ومركبات معتمدة",
    landing_support: "دعم على مدار الساعة",
    landing_support_desc: "نحن دائماً هنا من أجلك",
    landing_driver_cta_title: "كن سائقاً في 366Transfer",
    landing_driver_cta_desc: "اكسب المال من خلال التوصيل من وإلى المطار",
    landing_driver_cta_btn: "سجل كسائق",
    landing_vehicles: "فئات المركبات",
    
    booking_title: "حجز رحلة",
    booking_vehicle: "فئة المركبة",
    booking_date: "التاريخ",
    booking_time: "الوقت",
    booking_flight: "رقم الرحلة",
    booking_passengers: "الركاب",
    booking_adults: "بالغون",
    booking_children: "أطفال",
    booking_child_seats: "مقاعد أطفال",
    booking_luggage: "الأمتعة",
    booking_comments: "ملاحظات",
    booking_submit: "طلب رحلة",
    booking_login_required: "يرجى تسجيل الدخول لحجز رحلة",
    
    dashboard_title: "رحلاتي",
    dashboard_subtitle: "إدارة حجوزاتك ومقارنة العروض",
    dashboard_total: "إجمالي الطلبات",
    dashboard_with_offers: "مع عروض",
    dashboard_booked: "محجوز",
    dashboard_login_required: "تسجيل الدخول مطلوب",
    dashboard_login_desc: "يرجى تسجيل الدخول لعرض رحلاتك",
    dashboard_login_btn: "تسجيل الدخول",
    dashboard_no_transfers: "لا توجد رحلات بعد",
    dashboard_no_transfers_desc: "احجز رحلتك الأولى من الصفحة الرئيسية",
    dashboard_offers: "العروض",
    dashboard_offers_available: "عروض متاحة",
    dashboard_booked_driver: "السائق المحجوز",
    dashboard_trips: "رحلات",
    // auto-translated fallback, needs human review
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "بطاقة",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "مدفوع ومحجوز",
    dashboard_paid: "مدفوع",
    dashboard_status_open: "مفتوح",
    dashboard_status_bidding: "عروض متاحة",
    dashboard_status_booked: "محجوز",
    dashboard_status_cancelled: "ملغي",
    dashboard_completed: "مكتمل",
    
    rating_title: "تقييم السائق",
    rating_punctuality: "الالتزام بالمواعيد",
    rating_cleanliness: "النظافة",
    rating_friendliness: "الود",
    rating_driving_style: "أسلوب القيادة",
    rating_comment: "تعليق (اختياري)",
    rating_submit: "إرسال التقييم",
    rating_thank_you: "شكرا لك!",
    rating_submitted: "تم إرسال تقييمك بنجاح.",
    rating_overall: "التقييم العام",
    rating_reviews: "تقييمات العملاء",
    
    admin_title: "لوحة الإدارة",
    admin_overview: "نظرة عامة",
    admin_pending: "الموافقات",
    admin_drivers: "السائقون",
    admin_companies: "الشركات",
    admin_transfers: "التحويلات",
    admin_payments: "المدفوعات",
    admin_users: "المستخدمون",
    admin_approve: "موافقة",
    admin_reject: "رفض",
    admin_block: "حظر",
    admin_unblock: "إلغاء الحظر",
    admin_documents: "المستندات",
    admin_export: "تصدير",
    admin_revenue: "الإيرادات",
    admin_active: "نشط",
    admin_blocked: "محظور",
    admin_search: "بحث...",
    
    profile_driver: "ملف السائق",
    profile_company: "ملف الشركة",
    profile_member_since: "عضو منذ",
    profile_trips: "رحلات",
    profile_fleet: "أسطول المركبات",
    
    payment_processing: "جاري معالجة الدفع...",
    payment_success: "تم الدفع بنجاح! تم تأكيد حجزك.",
    payment_cancelled: "تم إلغاء الدفع. يمكنك المحاولة مرة أخرى.",
    payment_error: "تعذر التحقق من حالة الدفع.",
    payment_paypal_processing: "جاري معالجة دفع PayPal...",
    payment_paypal_success: "تم دفع PayPal بنجاح! تم تأكيد حجزك.",
    payment_paypal_error: "خطأ في تأكيد دفع PayPal.",
    
    driver_title: "بوابة السائق",
    driver_new: "جديد",
    driver_my_offers: "عروضي",
    driver_offer_price: "تقديم عرض",
    driver_requests: "طلبات جديدة",
    driver_active_offers: "عروض نشطة",
    driver_bookings: "حجوزات",
    driver_search: "بحث...",
    
    common_back: "رجوع",
    common_home: "الرئيسية",
    common_loading: "جاري التحميل...",
    common_error: "خطأ",
    common_save: "حفظ",
    common_cancel: "إلغاء",
    common_delete: "حذف",
    common_edit: "تعديل",
    common_add: "إضافة",
    common_close: "إغلاق",
    common_confirm: "تأكيد",
    common_persons: "أشخاص",
    common_km: "كم",
    common_min: "دقيقة",
    common_about: "من نحن",
    common_contact: "اتصل بنا",
    common_language: "اللغة",
    
    company_title: "تسجيل شركة",
    company_subtitle: "إدارة الأسطول لشركات النقل",
    company_name: "اسم الشركة",
    company_contact: "جهة الاتصال",
    company_phone: "الهاتف",
    company_region: "المنطقة",
    company_languages: "اللغات",
    company_step_company: "الشركة",
    company_step_vehicles: "المركبات",
    company_step_drivers: "السائقون",
    company_next_vehicles: "التالي: المركبات",
    company_next_drivers: "التالي: السائقون",
    company_submit: "تسجيل الشركة",
    company_add_vehicle: "إضافة مركبة",
    company_add_driver: "إضافة سائق",
    company_success: "تم تسجيل الشركة!",
    company_success_desc: "سيتم مراجعة شركتك من قبل فريقنا.",
    company_summary: "ملخص",
    company_vehicles_count: "مركبات",
    company_drivers_count: "سائقون",
    
    footer_rights: "جميع الحقوق محفوظة",
    footer_imprint: "بيانات الناشر",
    footer_privacy: "الخصوصية",
    footer_terms: "الشروط",
    
    landing_bullet1: "مركبات فاخرة بأسعار اقتصادية",
    landing_bullet2: "قارن عروض السائقين فوراً",
    landing_bullet3: "ادفع بأمان ببطاقة الائتمان وPayPal والمزيد",
    landing_tab_transfer: "توصيل",
    landing_tab_hourly: "بالساعة",
    landing_continue: "متابعة",
    landing_vehicles_subtitle: "من الاقتصادية إلى الفاخرة - اعثر على الرحلة المثالية",
    landing_easy_payment: "دفع سهل",
    landing_easy_payment_desc: "Visa، Mastercard، PayPal، Twint والمزيد",
    landing_hourly_rental: "تأجير بالساعة",

    // Driver Dashboard extra
    driver_portal: "بوابة السائق",
    driver_tab_new: "جديد",
    driver_tab_vehicles: "المركبات",
    driver_tab_profile: "ملفي الشخصي",
    driver_tab_with_offers: "مع عروضي",
    driver_tab_bookings: "الحجوزات",
    driver_sort_created: "تاريخ الإنشاء",
    driver_filter: "تصفية",
    driver_search_placeholder: "بحث...",
    driver_col_id: "#",
    driver_col_ride_date: "تاريخ الرحلة",
    driver_col_type: "النوع",
    driver_col_distance: "المسافة",
    driver_col_from: "من",
    driver_col_to: "إلى",
    driver_col_passengers: "الركاب",
    driver_col_transport: "النقل",
    driver_col_your_offer: "عرضك",
    driver_offered: "تم التقديم",
    driver_offer_price_btn: "تقديم سعر",
    driver_no_requests: "لا توجد طلبات متاحة",
    driver_no_bookings: "لا توجد حجوزات بعد",
    driver_new_requests: "طلبات جديدة",
    driver_active_offers_count: "عروض نشطة",
    driver_bookings_count: "حجوزات",
    driver_created: "أنشئ",
    driver_return: "عودة",
    driver_tbd: "غير محدد",
    driver_submit_offer: "تقديم سعر",
    driver_make_offer_title: "تقديم عرض",
    driver_make_offer_desc: "حدد سعرك لهذه الرحلة",
    driver_your_price: "سعرك (يورو)",
    driver_notes_label: "ملاحظات (اختياري)",
    driver_notes_placeholder: "مثال: زجاجة ماء مجانية، مقعد أطفال متاح...",
    driver_price_placeholder: "مثال: 45",
    driver_price_suggestion: "اقتراح السعر",
    driver_price_recommended: "موصى به",
    driver_price_range: "النطاق",
    driver_cancel: "إلغاء",
    driver_login_required: "تسجيل الدخول مطلوب",
    driver_login_desc: "يرجى تسجيل الدخول للوصول إلى لوحة السائق.",
    driver_login_btn: "تسجيل الدخول",
    driver_no_profile: "لا يوجد ملف سائق",
    driver_no_profile_desc: "يجب التسجيل كسائق أولاً.",
    driver_register_btn: "التسجيل كسائق",
    driver_pending_title: "الطلب قيد المراجعة",
    driver_pending_desc: "طلب التسجيل كسائق قيد المراجعة. يرجى الانتظار.",
    driver_rejected_title: "تم رفض الطلب",
    driver_rejected_desc: "للأسف، تم رفض طلبك.",
    driver_complete_btn: "مكتمل",
    driver_complete_confirm: "هل تريد وضع علامة مكتمل على هذه الرحلة؟ سيتلقى العميل بريد تقييم.",
    driver_complete_success: "تم وضع علامة مكتمل على الرحلة! تم دعوة العميل للتقييم عبر البريد.",
    driver_offer_success: "تم إرسال العرض بنجاح!",
    driver_offer_invalid_price: "يرجى إدخال سعر صالح",
    driver_status_completed: "مكتمل",
    driver_status_booked: "محجوز",
    driver_docs_missing_alert: "يرجى تحميل جميع المستندات المطلوبة قبل المتابعة.",
    driver_docs_title: "تحميل المستندات",
    driver_docs_subtitle: "يرجى تحميل جميع المستندات المطلوبة",
    driver_docs_selfie: "صورة شخصية مع الرخصة",
    driver_docs_registration: "تسجيل المركبة",
    driver_docs_vehicle_photo: "صورة المركبة",
    driver_docs_insurance: "شهادة التأمين",
    driver_docs_license: "رخصة النقل (اختياري)",
    driver_docs_required: "مطلوب",
    driver_docs_optional: "اختياري",
    driver_docs_uploaded: "تم التحميل",
    driver_docs_camera: "كاميرا",
    driver_docs_upload: "تحميل",
    driver_docs_complete_btn: "تم والمتابعة",
    driver_docs_btn: "المستندات",
    driver_docs_incomplete: "المستندات غير مكتملة",
    driver_docs_all_complete: "جميع المستندات موجودة",
    driver_terms_accept_text: "أوافق على",
    driver_terms_link: "شروط وأحكام السائق",
    driver_terms_binding_text: "عرضي ملزم. أنا ملتزم بتنفيذ النقل في الوقت والسعر المتفق عليهما بمجرد حجز العميل ودفعه.",
    
    // Profile Management
    profile_settings: "إعدادات الملف الشخصي",
    profile_edit: "تعديل الملف الشخصي",
    profile_change_password: "تغيير كلمة المرور",
    profile_logout: "تسجيل الخروج",
    profile_name: "الاسم",
    profile_email: "البريد الإلكتروني",
    profile_phone: "الهاتف",
    profile_save: "حفظ",
    profile_cancel: "إلغاء",
    profile_current_password: "كلمة المرور الحالية",
    profile_new_password: "كلمة المرور الجديدة",
    profile_confirm_password: "تأكيد كلمة المرور",
    profile_password_mismatch: "كلمتا المرور غير متطابقتين",
    profile_password_changed: "تم تغيير كلمة المرور بنجاح",
    profile_updated: "تم تحديث الملف الشخصي بنجاح",
    profile_reapproval_warning: "تغيير الاسم أو البريد الإلكتروني أو بيانات المركبة يتطلب إعادة الموافقة على حسابك.",
    profile_reapproval_triggered: "يحتاج حسابك إلى إعادة موافقة من المسؤول.",
    profile_vehicle_info: "معلومات المركبة",
    profile_vehicle_make: "الشركة المصنعة",
    profile_vehicle_model: "الموديل",
    profile_vehicle_year: "سنة الصنع",
    profile_vehicle_color: "اللون",
    profile_vehicle_plate: "رقم اللوحة",
    profile_vehicle_type: "نوع المركبة",
    profile_vehicle_passengers: "الركاب",
    profile_vehicle_luggage: "الأمتعة",
  },
  
  ru: {
    nav_for_drivers: "Для водителей",
    nav_for_companies: "Для компаний",
    nav_driver_dashboard: "Панель водителя",
    nav_my_transfers: "Мои трансферы",
    nav_admin: "Админ",
    nav_login: "Войти",
    nav_logout: "Выйти",
    
    auth_welcome: "С возвращением",
    auth_register_title: "Создать аккаунт",
    auth_login_subtitle: "Войдите, чтобы управлять трансферами",
    auth_register_subtitle: "Создайте аккаунт для бронирования",
    auth_name: "Полное имя",
    auth_email: "Электронная почта",
    auth_password: "Пароль",
    auth_phone: "Номер телефона",
    auth_login_btn: "Войти",
    auth_register_btn: "Создать аккаунт",
    auth_switch_to_register: "Нет аккаунта? Зарегистрироваться",
    auth_switch_to_login: "Уже есть аккаунт? Войти",
    auth_fill_all: "Пожалуйста, заполните все обязательные поля",
    auth_invalid: "Неверный email или пароль",
    
    landing_hero_title: "Трансферы из аэропорта по лучшей цене",
    landing_hero_subtitle: "Сравнивайте предложения проверенных водителей и бронируйте за минуты",
    landing_from: "Откуда?",
    landing_to: "Куда?",
    landing_search: "Найти трансфер",
    landing_how_it_works: "Как это работает",
    landing_step1_title: "Укажите маршрут",
    landing_step1_desc: "Введите пункт отправления и назначения",
    landing_step2_title: "Сравните предложения",
    landing_step2_desc: "Получите предложения от водителей",
    landing_step3_title: "Забронируйте и оплатите",
    landing_step3_desc: "Выберите лучшее предложение",
    landing_why_title: "Почему 366Transfer?",
    landing_get_app_title: "Скачать приложение",
    landing_get_app_desc: "Бронируйте быстрее, управляйте трансферами и получайте push-уведомления прямо на телефон.",
    landing_get_app_hint: "Отсканируйте QR-код камерой телефона, чтобы открыть приложение.",
    landing_best_price: "Лучшая цена",
    landing_best_price_desc: "Сравнивайте предложения и экономьте",
    landing_safe: "Безопасно и надёжно",
    landing_safe_desc: "Проверенные водители и автомобили",
    landing_support: "Поддержка 24/7",
    landing_support_desc: "Мы всегда на связи",
    landing_driver_cta_title: "Станьте водителем 366Transfer",
    landing_driver_cta_desc: "Зарабатывайте на трансферах из аэропорта",
    landing_driver_cta_btn: "Стать водителем",
    landing_vehicles: "Классы автомобилей",
    
    booking_title: "Забронировать трансфер",
    booking_vehicle: "Класс автомобиля",
    booking_date: "Дата",
    booking_time: "Время",
    booking_flight: "Номер рейса",
    booking_passengers: "Пассажиры",
    booking_adults: "Взрослые",
    booking_children: "Дети",
    booking_child_seats: "Детские кресла",
    booking_luggage: "Багаж",
    booking_comments: "Комментарии",
    booking_submit: "Запросить трансфер",
    booking_login_required: "Войдите, чтобы забронировать трансфер",
    
    dashboard_title: "Мои трансферы",
    dashboard_subtitle: "Управляйте бронированиями и сравнивайте предложения",
    dashboard_total: "Всего запросов",
    dashboard_with_offers: "С предложениями",
    dashboard_booked: "Забронировано",
    dashboard_login_required: "Требуется авторизация",
    dashboard_login_desc: "Войдите, чтобы увидеть ваши трансферы",
    dashboard_login_btn: "Войти",
    dashboard_no_transfers: "Пока нет трансферов",
    dashboard_no_transfers_desc: "Забронируйте первый трансфер на главной",
    dashboard_offers: "Предложения",
    dashboard_offers_available: "Предложения доступны",
    dashboard_booked_driver: "Забронированный водитель",
    dashboard_trips: "поездок",
    // auto-translated fallback, needs human review
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "Картой",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "Оплачено и забронировано",
    dashboard_paid: "Оплачено",
    dashboard_status_open: "Открыт",
    dashboard_status_bidding: "Есть предложения",
    dashboard_status_booked: "Забронирован",
    dashboard_status_cancelled: "Отменён",
    dashboard_completed: "Завершён",
    
    rating_title: "Оценка водителя",
    rating_punctuality: "Пунктуальность",
    rating_cleanliness: "Чистота",
    rating_friendliness: "Дружелюбие",
    rating_driving_style: "Стиль вождения",
    rating_comment: "Комментарий (необязательно)",
    rating_submit: "Отправить оценку",
    rating_thank_you: "Спасибо!",
    rating_submitted: "Ваша оценка успешно отправлена.",
    rating_overall: "Общая оценка",
    rating_reviews: "Отзывы клиентов",
    
    admin_title: "Панель администратора",
    admin_overview: "Обзор",
    admin_pending: "Одобрение",
    admin_drivers: "Водители",
    admin_companies: "Компании",
    admin_transfers: "Трансферы",
    admin_payments: "Платежи",
    admin_users: "Пользователи",
    admin_approve: "Одобрить",
    admin_reject: "Отклонить",
    admin_block: "Заблокировать",
    admin_unblock: "Разблокировать",
    admin_documents: "Документы",
    admin_export: "Экспорт",
    admin_revenue: "Доход",
    admin_active: "Активен",
    admin_blocked: "Заблокирован",
    admin_search: "Поиск...",
    
    profile_driver: "Профиль водителя",
    profile_company: "Профиль компании",
    profile_member_since: "Участник с",
    profile_trips: "поездок",
    profile_fleet: "Автопарк",
    
    payment_processing: "Обработка платежа...",
    payment_success: "Оплата прошла успешно! Бронирование подтверждено.",
    payment_cancelled: "Оплата отменена. Попробуйте снова.",
    payment_error: "Не удалось проверить статус оплаты.",
    payment_paypal_processing: "Обработка PayPal-платежа...",
    payment_paypal_success: "PayPal-оплата прошла успешно! Бронирование подтверждено.",
    payment_paypal_error: "Ошибка подтверждения PayPal-платежа.",
    
    driver_title: "Портал водителя",
    driver_new: "Новые",
    driver_my_offers: "Мои предложения",
    driver_offer_price: "Предложить цену",
    driver_requests: "новых запросов",
    driver_active_offers: "активных предложений",
    driver_bookings: "бронирований",
    driver_search: "Поиск...",
    
    common_back: "Назад",
    common_home: "Главная",
    common_loading: "Загрузка...",
    common_error: "Ошибка",
    common_save: "Сохранить",
    common_cancel: "Отмена",
    common_delete: "Удалить",
    common_edit: "Редактировать",
    common_add: "Добавить",
    common_close: "Закрыть",
    common_confirm: "Подтвердить",
    common_persons: "чел.",
    common_km: "км",
    common_min: "мин",
    common_about: "О нас",
    common_contact: "Контакты",
    common_language: "Язык",
    
    company_title: "Регистрация компании",
    company_subtitle: "Управление автопарком для транспортных компаний",
    company_name: "Название компании",
    company_contact: "Контактное лицо",
    company_phone: "Телефон",
    company_region: "Регион",
    company_languages: "Языки",
    company_step_company: "Компания",
    company_step_vehicles: "Транспорт",
    company_step_drivers: "Водители",
    company_next_vehicles: "Далее: Транспорт",
    company_next_drivers: "Далее: Водители",
    company_submit: "Зарегистрировать компанию",
    company_add_vehicle: "Добавить транспорт",
    company_add_driver: "Добавить водителя",
    company_success: "Компания зарегистрирована!",
    company_success_desc: "Ваша компания будет проверена нашей командой.",
    company_summary: "Итого",
    company_vehicles_count: "Транспорт",
    company_drivers_count: "Водители",
    
    footer_rights: "Все права защищены",
    footer_imprint: "Импрессум",
    footer_privacy: "Конфиденциальность",
    footer_terms: "Условия",
    
    landing_bullet1: "Премиум автомобили по экономичным ценам",
    landing_bullet2: "Сравнивайте предложения водителей мгновенно",
    landing_bullet3: "Безопасная оплата картой, PayPal и другими способами",
    landing_tab_transfer: "Трансфер",
    landing_tab_hourly: "Почасовая",
    landing_continue: "Далее",
    landing_vehicles_subtitle: "От эконома до люкса - найдите идеальную поездку",
    landing_easy_payment: "Простая оплата",
    landing_easy_payment_desc: "Visa, Mastercard, PayPal, Twint и другие",
    landing_hourly_rental: "Почасовая аренда",

    // Driver Dashboard extra
    driver_portal: "Портал водителя",
    driver_tab_new: "Новые",
    driver_tab_vehicles: "Транспорт",
    driver_tab_profile: "Мой профиль",
    driver_tab_with_offers: "С моими предложениями",
    driver_tab_bookings: "Бронирования",
    driver_sort_created: "Дата создания",
    driver_filter: "Фильтр",
    driver_search_placeholder: "Поиск...",
    driver_col_id: "#",
    driver_col_ride_date: "Дата поездки",
    driver_col_type: "Тип",
    driver_col_distance: "Расстояние",
    driver_col_from: "Откуда",
    driver_col_to: "Куда",
    driver_col_passengers: "Пассажиры",
    driver_col_transport: "Транспорт",
    driver_col_your_offer: "Ваше предложение",
    driver_offered: "Предложено",
    driver_offer_price_btn: "Предложить цену",
    driver_no_requests: "Нет доступных запросов",
    driver_no_bookings: "Пока нет бронирований",
    driver_new_requests: "новых запросов",
    driver_active_offers_count: "активных предложений",
    driver_bookings_count: "бронирований",
    driver_created: "создан",
    driver_return: "Обратно",
    driver_tbd: "уточняется",
    driver_submit_offer: "Предложить цену",
    driver_make_offer_title: "Сделать предложение",
    driver_make_offer_desc: "Укажите вашу цену за эту поездку",
    driver_your_price: "Ваша цена (EUR)",
    driver_notes_label: "Заметки (необязательно)",
    driver_notes_placeholder: "Например: бутылка воды включена, детское кресло доступно...",
    driver_price_placeholder: "Например: 45",
    driver_price_suggestion: "Предложение цены",
    driver_price_recommended: "рекомендовано",
    driver_price_range: "Диапазон",
    driver_cancel: "Отмена",
    driver_login_required: "Требуется авторизация",
    driver_login_desc: "Войдите, чтобы получить доступ к панели водителя.",
    driver_login_btn: "Войти",
    driver_no_profile: "Нет профиля водителя",
    driver_no_profile_desc: "Сначала необходимо зарегистрироваться как водитель.",
    driver_register_btn: "Зарегистрироваться как водитель",
    driver_pending_title: "Заявка на рассмотрении",
    driver_pending_desc: "Ваша заявка водителя рассматривается. Пожалуйста, подождите.",
    driver_rejected_title: "Заявка отклонена",
    driver_rejected_desc: "К сожалению, ваша заявка была отклонена.",
    driver_complete_btn: "Завершено",
    driver_complete_confirm: "Отметить поездку как завершённую? Клиент получит письмо с просьбой оставить отзыв.",
    driver_complete_success: "Поездка отмечена как завершённая! Клиент приглашён оставить отзыв по email.",
    driver_offer_success: "Предложение успешно отправлено!",
    driver_offer_invalid_price: "Пожалуйста, введите корректную цену",
    driver_status_completed: "Завершён",
    driver_status_booked: "Забронирован",
    driver_docs_missing_alert: "Пожалуйста, загрузите все необходимые документы перед продолжением.",
    driver_docs_title: "Загрузка документов",
    driver_docs_subtitle: "Пожалуйста, загрузите все необходимые документы",
    driver_docs_selfie: "Селфи с правами",
    driver_docs_registration: "Регистрация транспорта",
    driver_docs_vehicle_photo: "Фото транспорта",
    driver_docs_insurance: "Страховой сертификат",
    driver_docs_license: "Лицензия на перевозку (необязательно)",
    driver_docs_required: "Обязательно",
    driver_docs_optional: "Необязательно",
    driver_docs_uploaded: "Загружено",
    driver_docs_camera: "Камера",
    driver_docs_upload: "Загрузить",
    driver_docs_complete_btn: "Готово и продолжить",
    driver_docs_btn: "Документы",
    driver_docs_incomplete: "Документы неполные",
    driver_docs_all_complete: "Все документы загружены",
    driver_terms_accept_text: "Я принимаю",
    driver_terms_link: "Условия для водителей",
    driver_terms_binding_text: "Моё предложение является обязательным. Я обязуюсь выполнить трансфер в согласованное время и по согласованной цене после бронирования и оплаты клиентом.",
    
    // Profile Management
    profile_settings: "Настройки профиля",
    profile_edit: "Редактировать профиль",
    profile_change_password: "Изменить пароль",
    profile_logout: "Выйти",
    profile_name: "Имя",
    profile_email: "Эл. почта",
    profile_phone: "Телефон",
    profile_save: "Сохранить",
    profile_cancel: "Отмена",
    profile_current_password: "Текущий пароль",
    profile_new_password: "Новый пароль",
    profile_confirm_password: "Подтвердите пароль",
    profile_password_mismatch: "Пароли не совпадают",
    profile_password_changed: "Пароль успешно изменён",
    profile_updated: "Профиль успешно обновлён",
    profile_reapproval_warning: "Изменение имени, эл. почты или данных транспорта требует повторного одобрения аккаунта.",
    profile_reapproval_triggered: "Ваш аккаунт должен быть повторно одобрен администратором.",
    profile_vehicle_info: "Данные транспорта",
    profile_vehicle_make: "Марка",
    profile_vehicle_model: "Модель",
    profile_vehicle_year: "Год",
    profile_vehicle_color: "Цвет",
    profile_vehicle_plate: "Номерной знак",
    profile_vehicle_type: "Тип транспорта",
    profile_vehicle_passengers: "Пассажиры",
    profile_vehicle_luggage: "Багаж",
  },

  it: {
    nav_for_drivers: "Per Autisti",
    nav_for_companies: "Per Aziende",
    nav_driver_dashboard: "Dashboard Autista",
    nav_my_transfers: "I Miei Transfer",
    nav_admin: "Admin",
    nav_login: "Accedi",
    nav_logout: "Esci",

    auth_welcome: "Bentornato",
    auth_register_title: "Crea Account",
    auth_login_subtitle: "Accedi per gestire i tuoi transfer",
    auth_register_subtitle: "Crea un account per il tuo transfer",
    auth_name: "Nome Completo",
    auth_email: "Indirizzo Email",
    auth_password: "Password",
    auth_phone: "Numero di Telefono",
    auth_login_btn: "Accedi",
    auth_register_btn: "Crea Account",
    auth_switch_to_register: "Non hai un account? Registrati",
    auth_switch_to_login: "Hai già un account? Accedi",
    auth_fill_all: "Compila tutti i campi obbligatori",
    auth_invalid: "Email o password non validi",

    landing_hero_title: "Transfer Aeroportuali al Miglior Prezzo",
    landing_hero_subtitle: "Confronta le offerte di autisti verificati e prenota il tuo transfer in pochi minuti",
    landing_from: "Da dove?",
    landing_to: "Dove?",
    landing_search: "Cerca Transfer",
    landing_how_it_works: "Come Funziona",
    landing_step1_title: "Inserisci il Percorso",
    landing_step1_desc: "Inserisci il punto di ritiro e di arrivo",
    landing_step2_title: "Confronta le Offerte",
    landing_step2_desc: "Ricevi offerte dagli autisti",
    landing_step3_title: "Prenota e Paga",
    landing_step3_desc: "Scegli la migliore offerta",
    landing_why_title: "Perché 366Transfer?",
    landing_get_app_title: "Scarica l'app",
    landing_get_app_desc: "Prenota più velocemente, gestisci i tuoi trasferimenti e ricevi notifiche push direttamente sul telefono.",
    landing_get_app_hint: "Scansiona il codice QR con la fotocamera del telefono per aprire direttamente l'app.",
    landing_best_price: "Miglior Prezzo",
    landing_best_price_desc: "Confronta le offerte e risparmia",
    landing_safe: "Sicuro e Affidabile",
    landing_safe_desc: "Autisti e veicoli verificati",
    landing_support: "Supporto 24/7",
    landing_support_desc: "Siamo sempre qui per te",
    landing_driver_cta_title: "Diventa Autista di 366Transfer",
    landing_driver_cta_desc: "Guadagna con i transfer aeroportuali",
    landing_driver_cta_btn: "Registrati come Autista",
    landing_vehicles: "Le Nostre Classi di Veicoli",

    booking_title: "Prenota Transfer",
    booking_vehicle: "Classe Veicolo",
    booking_date: "Data",
    booking_time: "Ora",
    booking_flight: "Numero Volo",
    booking_passengers: "Passeggeri",
    booking_adults: "Adulti",
    booking_children: "Bambini",
    booking_child_seats: "Seggiolini",
    booking_luggage: "Bagagli",
    booking_comments: "Commenti",
    booking_submit: "Richiedi Transfer",
    booking_login_required: "Accedi per prenotare un transfer",

    dashboard_title: "I Miei Transfer",
    dashboard_subtitle: "Gestisci le tue prenotazioni e confronta le offerte",
    dashboard_total: "Richieste Totali",
    dashboard_with_offers: "Con Offerte",
    dashboard_booked: "Prenotato",
    dashboard_login_required: "Accesso Richiesto",
    dashboard_login_desc: "Accedi per visualizzare i tuoi transfer",
    dashboard_login_btn: "Accedi",
    dashboard_no_transfers: "Nessun Transfer",
    dashboard_no_transfers_desc: "Prenota il tuo primo transfer dalla homepage",
    dashboard_offers: "Offerte",
    dashboard_offers_available: "Offerte disponibili",
    dashboard_booked_driver: "Autista Prenotato",
    dashboard_trips: "viaggi",
    // auto-translated fallback, needs human review
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "Carta",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "Pagato e Prenotato",
    dashboard_paid: "Pagato",
    dashboard_status_open: "Aperto",
    dashboard_status_bidding: "Offerte disponibili",
    dashboard_status_booked: "Prenotato",
    dashboard_status_cancelled: "Annullato",
    dashboard_completed: "Completato",

    rating_title: "Valutazione Autista",
    rating_punctuality: "Puntualità",
    rating_cleanliness: "Pulizia",
    rating_friendliness: "Cordialità",
    rating_driving_style: "Stile di Guida",
    rating_comment: "Commento (opzionale)",
    rating_submit: "Invia Valutazione",
    rating_thank_you: "Grazie!",
    rating_submitted: "La tua valutazione è stata inviata con successo.",
    rating_overall: "Valutazione Complessiva",
    rating_reviews: "Recensioni Clienti",

    admin_title: "Dashboard Admin",
    admin_overview: "Panoramica",
    admin_pending: "Approvazioni",
    admin_drivers: "Autisti",
    admin_companies: "Aziende",
    admin_transfers: "Transfer",
    admin_payments: "Pagamenti",
    admin_users: "Utenti",
    admin_approve: "Approva",
    admin_reject: "Rifiuta",
    admin_block: "Blocca",
    admin_unblock: "Sblocca",
    admin_documents: "Documenti",
    admin_export: "Esporta",
    admin_revenue: "Fatturato",
    admin_active: "Attivo",
    admin_blocked: "Bloccato",
    admin_search: "Cerca...",

    profile_driver: "Profilo Autista",
    profile_company: "Profilo Azienda",
    profile_member_since: "Membro dal",
    profile_trips: "viaggi",
    profile_fleet: "Flotta Veicoli",

    payment_processing: "Pagamento in elaborazione...",
    payment_success: "Pagamento riuscito! La tua prenotazione è confermata.",
    payment_cancelled: "Pagamento annullato. Puoi riprovare.",
    payment_error: "Impossibile verificare lo stato del pagamento.",
    payment_paypal_processing: "Pagamento PayPal in elaborazione...",
    payment_paypal_success: "Pagamento PayPal riuscito! La tua prenotazione è confermata.",
    payment_paypal_error: "Errore nella conferma del pagamento PayPal.",

    driver_title: "Portale Autista",
    driver_new: "Nuovo",
    driver_my_offers: "Le Mie Offerte",
    driver_offer_price: "Fai un'Offerta",
    driver_requests: "nuove richieste",
    driver_active_offers: "offerte attive",
    driver_bookings: "prenotazioni",
    driver_search: "Cerca...",

    common_back: "Indietro",
    common_home: "Home",
    common_loading: "Caricamento...",
    common_error: "Errore",
    common_save: "Salva",
    common_cancel: "Annulla",
    common_delete: "Elimina",
    common_edit: "Modifica",
    common_add: "Aggiungi",
    common_close: "Chiudi",
    common_confirm: "Conferma",
    common_persons: "pers.",
    common_km: "km",
    common_min: "min",
    common_about: "Chi Siamo",
    common_contact: "Contatti",
    common_language: "Lingua",

    company_title: "Registra Azienda",
    company_subtitle: "Gestione flotta per aziende di trasporto",
    company_name: "Nome Azienda",
    company_contact: "Persona di Contatto",
    company_phone: "Telefono",
    company_region: "Regione",
    company_languages: "Lingue",
    company_step_company: "Azienda",
    company_step_vehicles: "Veicoli",
    company_step_drivers: "Autisti",
    company_next_vehicles: "Avanti: Veicoli",
    company_next_drivers: "Avanti: Autisti",
    company_submit: "Registra Azienda",
    company_add_vehicle: "Aggiungi Veicolo",
    company_add_driver: "Aggiungi Autista",
    company_success: "Azienda Registrata!",
    company_success_desc: "La tua azienda sarà verificata dal nostro team.",
    company_summary: "Riepilogo",
    company_vehicles_count: "Veicoli",
    company_drivers_count: "Autisti",

    footer_rights: "Tutti i diritti riservati",
    footer_imprint: "Impronta",
    footer_privacy: "Privacy",
    footer_terms: "Termini",

    landing_bullet1: "Veicoli premium a prezzi economici",
    landing_bullet2: "Confronta le offerte degli autisti istantaneamente",
    landing_bullet3: "Paga in sicurezza con carta di credito, PayPal e altro",
    landing_tab_transfer: "Transfer",
    landing_tab_hourly: "Orario",
    landing_continue: "Continua",
    landing_vehicles_subtitle: "Dall'Economy al Lusso - trova il viaggio perfetto",
    landing_easy_payment: "Pagamento Facile",
    landing_easy_payment_desc: "Visa, Mastercard, PayPal, Twint e altro",
    landing_hourly_rental: "Noleggio Orario",

    driver_portal: "Portale Autista",
    driver_tab_new: "Nuovo",
    driver_tab_vehicles: "Veicoli",
    driver_tab_profile: "Il mio profilo",
    driver_tab_with_offers: "Con le mie offerte",
    driver_tab_bookings: "Prenotazioni",
    driver_sort_created: "Data creazione",
    driver_filter: "Filtro",
    driver_search_placeholder: "Cerca...",
    driver_col_id: "#",
    driver_col_ride_date: "Data corsa",
    driver_col_type: "Tipo",
    driver_col_distance: "Distanza",
    driver_col_from: "Da",
    driver_col_to: "A",
    driver_col_passengers: "Passeggeri",
    driver_col_transport: "Trasporto",
    driver_col_your_offer: "La tua offerta",
    driver_offered: "Offerto",
    driver_offer_price_btn: "Offri prezzo",
    driver_no_requests: "Nessuna richiesta disponibile",
    driver_no_bookings: "Nessuna prenotazione",
    driver_new_requests: "nuove richieste",
    driver_active_offers_count: "offerte attive",
    driver_bookings_count: "prenotazioni",
    driver_created: "creato",
    driver_return: "Ritorno",
    driver_tbd: "da definire",
    driver_submit_offer: "Offri prezzo",
    driver_make_offer_title: "Fai un'Offerta",
    driver_make_offer_desc: "Imposta il tuo prezzo per questa corsa",
    driver_your_price: "Il Tuo Prezzo (EUR)",
    driver_notes_label: "Note (opzionale)",
    driver_notes_placeholder: "es. Bottiglia d'acqua inclusa, seggiolino disponibile...",
    driver_price_placeholder: "es. 45",
    driver_price_suggestion: "Suggerimento Prezzo",
    driver_price_recommended: "consigliato",
    driver_price_range: "Intervallo",
    driver_cancel: "Annulla",
    driver_login_required: "Accesso Richiesto",
    driver_login_desc: "Accedi per accedere al dashboard autista.",
    driver_login_btn: "Accedi",
    driver_no_profile: "Nessun Profilo Autista",
    driver_no_profile_desc: "Devi prima registrarti come autista.",
    driver_register_btn: "Registrati come Autista",
    driver_pending_title: "Candidatura in Revisione",
    driver_pending_desc: "La tua candidatura come autista è in fase di revisione. Attendi.",
    driver_rejected_title: "Candidatura Rifiutata",
    driver_rejected_desc: "Purtroppo la tua candidatura è stata rifiutata.",
    driver_complete_btn: "Completato",
    driver_complete_confirm: "Contrassegnare questa corsa come completata? Il cliente riceverà un'email di valutazione.",
    driver_complete_success: "Corsa completata! Il cliente è stato invitato a valutare via email.",
    driver_offer_success: "Offerta inviata con successo!",
    driver_offer_invalid_price: "Inserisci un prezzo valido",
    driver_status_completed: "Completato",
    driver_status_booked: "Prenotato",
    driver_docs_missing_alert: "Carica tutti i documenti richiesti prima di procedere.",
    driver_docs_title: "Carica Documenti",
    driver_docs_subtitle: "Carica tutti i documenti richiesti",
    driver_docs_selfie: "Selfie con Patente",
    driver_docs_registration: "Registrazione Veicolo",
    driver_docs_vehicle_photo: "Foto Veicolo",
    driver_docs_insurance: "Certificato Assicurazione",
    driver_docs_license: "Licenza Trasporto (opzionale)",
    driver_docs_required: "Obbligatorio",
    driver_docs_optional: "Opzionale",
    driver_docs_uploaded: "Caricato",
    driver_docs_camera: "Fotocamera",
    driver_docs_upload: "Carica",
    driver_docs_complete_btn: "Fatto e Continua",
    driver_docs_btn: "Documenti",
    driver_docs_incomplete: "Documenti incompleti",
    driver_docs_all_complete: "Tutti i documenti caricati",
    driver_terms_accept_text: "Accetto i",
    driver_terms_link: "Termini e Condizioni Autista",
    driver_terms_binding_text: "La mia offerta è vincolante. Mi impegno a effettuare il transfer all'orario e al prezzo concordati una volta che il cliente prenota e paga.",

    profile_settings: "Impostazioni Profilo",
    profile_edit: "Modifica Profilo",
    profile_change_password: "Cambia Password",
    profile_logout: "Esci",
    profile_name: "Nome",
    profile_email: "Email",
    profile_phone: "Telefono",
    profile_save: "Salva",
    profile_cancel: "Annulla",
    profile_current_password: "Password Attuale",
    profile_new_password: "Nuova Password",
    profile_confirm_password: "Conferma Password",
    profile_password_mismatch: "Le password non corrispondono",
    profile_password_changed: "Password cambiata con successo",
    profile_updated: "Profilo aggiornato con successo",
    profile_reapproval_warning: "La modifica di nome, email o dati del veicolo richiede una nuova approvazione.",
    profile_reapproval_triggered: "Il tuo account deve essere riapprovato dall'admin.",
    profile_vehicle_info: "Informazioni Veicolo",
    profile_vehicle_make: "Marca",
    profile_vehicle_model: "Modello",
    profile_vehicle_year: "Anno",
    profile_vehicle_color: "Colore",
    profile_vehicle_plate: "Targa",
    profile_vehicle_type: "Tipo Veicolo",
    profile_vehicle_passengers: "Passeggeri",
    profile_vehicle_luggage: "Bagagli",
  },

  fr: {
    nav_for_drivers: "Pour les Chauffeurs",
    nav_for_companies: "Pour les Entreprises",
    nav_driver_dashboard: "Tableau de Bord Chauffeur",
    nav_my_transfers: "Mes Transferts",
    nav_admin: "Admin",
    nav_login: "Connexion",
    nav_logout: "Déconnexion",

    auth_welcome: "Bon retour",
    auth_register_title: "Créer un Compte",
    auth_login_subtitle: "Connectez-vous pour gérer vos transferts",
    auth_register_subtitle: "Créez un compte pour votre transfert",
    auth_name: "Nom Complet",
    auth_email: "Adresse Email",
    auth_password: "Mot de Passe",
    auth_phone: "Numéro de Téléphone",
    auth_login_btn: "Se Connecter",
    auth_register_btn: "Créer un Compte",
    auth_switch_to_register: "Pas de compte ? Inscrivez-vous",
    auth_switch_to_login: "Déjà un compte ? Connectez-vous",
    auth_fill_all: "Veuillez remplir tous les champs obligatoires",
    auth_invalid: "Email ou mot de passe invalide",

    landing_hero_title: "Transferts Aéroport au Meilleur Prix",
    landing_hero_subtitle: "Comparez les offres de chauffeurs vérifiés et réservez votre transfert en quelques minutes",
    landing_from: "D'où ?",
    landing_to: "Où ?",
    landing_search: "Rechercher un Transfert",
    landing_how_it_works: "Comment ça Marche",
    landing_step1_title: "Entrez le Trajet",
    landing_step1_desc: "Indiquez le lieu de prise en charge et de destination",
    landing_step2_title: "Comparez les Offres",
    landing_step2_desc: "Recevez des offres de chauffeurs",
    landing_step3_title: "Réservez et Payez",
    landing_step3_desc: "Choisissez la meilleure offre",
    landing_why_title: "Pourquoi 366Transfer ?",
    landing_get_app_title: "Téléchargez l'app",
    landing_get_app_desc: "Réservez plus rapidement, gérez vos transferts et recevez des notifications push directement sur votre téléphone.",
    landing_get_app_hint: "Scannez le code QR avec votre appareil photo pour ouvrir l'app directement.",
    landing_best_price: "Meilleur Prix",
    landing_best_price_desc: "Comparez les offres et économisez",
    landing_safe: "Sûr et Fiable",
    landing_safe_desc: "Chauffeurs et véhicules vérifiés",
    landing_support: "Support 24/7",
    landing_support_desc: "Nous sommes toujours là pour vous",
    landing_driver_cta_title: "Devenez Chauffeur chez 366Transfer",
    landing_driver_cta_desc: "Gagnez de l'argent avec les transferts aéroport",
    landing_driver_cta_btn: "S'inscrire comme Chauffeur",
    landing_vehicles: "Nos Classes de Véhicules",

    booking_title: "Réserver un Transfert",
    booking_vehicle: "Classe de Véhicule",
    booking_date: "Date",
    booking_time: "Heure",
    booking_flight: "Numéro de Vol",
    booking_passengers: "Passagers",
    booking_adults: "Adultes",
    booking_children: "Enfants",
    booking_child_seats: "Sièges Enfants",
    booking_luggage: "Bagages",
    booking_comments: "Commentaires",
    booking_submit: "Demander un Transfert",
    booking_login_required: "Connectez-vous pour réserver un transfert",

    dashboard_title: "Mes Transferts",
    dashboard_subtitle: "Gérez vos réservations et comparez les offres",
    dashboard_total: "Total des Demandes",
    dashboard_with_offers: "Avec Offres",
    dashboard_booked: "Réservé",
    dashboard_login_required: "Connexion Requise",
    dashboard_login_desc: "Connectez-vous pour voir vos transferts",
    dashboard_login_btn: "Se Connecter",
    dashboard_no_transfers: "Aucun Transfert",
    dashboard_no_transfers_desc: "Réservez votre premier transfert depuis la page d'accueil",
    dashboard_offers: "Offres",
    dashboard_offers_available: "Offres disponibles",
    dashboard_booked_driver: "Chauffeur Réservé",
    dashboard_trips: "trajets",
    // auto-translated fallback, needs human review
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "Carte",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "Payé et Réservé",
    dashboard_paid: "Payé",
    dashboard_status_open: "Ouvert",
    dashboard_status_bidding: "Offres disponibles",
    dashboard_status_booked: "Réservé",
    dashboard_status_cancelled: "Annulé",
    dashboard_completed: "Terminé",

    rating_title: "Évaluation du Chauffeur",
    rating_punctuality: "Ponctualité",
    rating_cleanliness: "Propreté",
    rating_friendliness: "Amabilité",
    rating_driving_style: "Style de Conduite",
    rating_comment: "Commentaire (optionnel)",
    rating_submit: "Envoyer l'Évaluation",
    rating_thank_you: "Merci !",
    rating_submitted: "Votre évaluation a été envoyée avec succès.",
    rating_overall: "Évaluation Globale",
    rating_reviews: "Avis Clients",

    admin_title: "Tableau de Bord Admin",
    admin_overview: "Aperçu",
    admin_pending: "Approbations",
    admin_drivers: "Chauffeurs",
    admin_companies: "Entreprises",
    admin_transfers: "Transferts",
    admin_payments: "Paiements",
    admin_users: "Utilisateurs",
    admin_approve: "Approuver",
    admin_reject: "Refuser",
    admin_block: "Bloquer",
    admin_unblock: "Débloquer",
    admin_documents: "Documents",
    admin_export: "Exporter",
    admin_revenue: "Chiffre d'Affaires",
    admin_active: "Actif",
    admin_blocked: "Bloqué",
    admin_search: "Rechercher...",

    profile_driver: "Profil Chauffeur",
    profile_company: "Profil Entreprise",
    profile_member_since: "Membre depuis",
    profile_trips: "trajets",
    profile_fleet: "Flotte de Véhicules",

    payment_processing: "Paiement en cours de traitement...",
    payment_success: "Paiement réussi ! Votre réservation est confirmée.",
    payment_cancelled: "Paiement annulé. Vous pouvez réessayer.",
    payment_error: "Impossible de vérifier le statut du paiement.",
    payment_paypal_processing: "Paiement PayPal en cours de traitement...",
    payment_paypal_success: "Paiement PayPal réussi ! Votre réservation est confirmée.",
    payment_paypal_error: "Erreur lors de la confirmation du paiement PayPal.",

    driver_title: "Portail Chauffeur",
    driver_new: "Nouveau",
    driver_my_offers: "Mes Offres",
    driver_offer_price: "Faire une Offre",
    driver_requests: "nouvelles demandes",
    driver_active_offers: "offres actives",
    driver_bookings: "réservations",
    driver_search: "Rechercher...",

    common_back: "Retour",
    common_home: "Accueil",
    common_loading: "Chargement...",
    common_error: "Erreur",
    common_save: "Enregistrer",
    common_cancel: "Annuler",
    common_delete: "Supprimer",
    common_edit: "Modifier",
    common_add: "Ajouter",
    common_close: "Fermer",
    common_confirm: "Confirmer",
    common_persons: "pers.",
    common_km: "km",
    common_min: "min",
    common_about: "À Propos",
    common_contact: "Contact",
    common_language: "Langue",

    company_title: "Enregistrer une Entreprise",
    company_subtitle: "Gestion de flotte pour les entreprises de transport",
    company_name: "Nom de l'Entreprise",
    company_contact: "Personne de Contact",
    company_phone: "Téléphone",
    company_region: "Région",
    company_languages: "Langues",
    company_step_company: "Entreprise",
    company_step_vehicles: "Véhicules",
    company_step_drivers: "Chauffeurs",
    company_next_vehicles: "Suivant : Véhicules",
    company_next_drivers: "Suivant : Chauffeurs",
    company_submit: "Enregistrer l'Entreprise",
    company_add_vehicle: "Ajouter un Véhicule",
    company_add_driver: "Ajouter un Chauffeur",
    company_success: "Entreprise Enregistrée !",
    company_success_desc: "Votre entreprise sera vérifiée par notre équipe.",
    company_summary: "Résumé",
    company_vehicles_count: "Véhicules",
    company_drivers_count: "Chauffeurs",

    footer_rights: "Tous droits réservés",
    footer_imprint: "Mentions Légales",
    footer_privacy: "Confidentialité",
    footer_terms: "CGV",

    landing_bullet1: "Véhicules premium à prix économiques",
    landing_bullet2: "Comparez les offres des chauffeurs instantanément",
    landing_bullet3: "Payez en toute sécurité par carte, PayPal et plus",
    landing_tab_transfer: "Transfert",
    landing_tab_hourly: "Horaire",
    landing_continue: "Continuer",
    landing_vehicles_subtitle: "De l'Économique au Luxe - trouvez le trajet parfait",
    landing_easy_payment: "Paiement Facile",
    landing_easy_payment_desc: "Visa, Mastercard, PayPal, Twint et plus",
    landing_hourly_rental: "Location Horaire",

    driver_portal: "Portail Chauffeur",
    driver_tab_new: "Nouveau",
    driver_tab_vehicles: "Véhicules",
    driver_tab_profile: "Mon profil",
    driver_tab_with_offers: "Avec mes offres",
    driver_tab_bookings: "Réservations",
    driver_sort_created: "Date de création",
    driver_filter: "Filtrer",
    driver_search_placeholder: "Rechercher...",
    driver_col_id: "#",
    driver_col_ride_date: "Date de course",
    driver_col_type: "Type",
    driver_col_distance: "Distance",
    driver_col_from: "De",
    driver_col_to: "À",
    driver_col_passengers: "Passagers",
    driver_col_transport: "Transport",
    driver_col_your_offer: "Votre offre",
    driver_offered: "Offert",
    driver_offer_price_btn: "Proposer un prix",
    driver_no_requests: "Aucune demande disponible",
    driver_no_bookings: "Aucune réservation",
    driver_new_requests: "nouvelles demandes",
    driver_active_offers_count: "offres actives",
    driver_bookings_count: "réservations",
    driver_created: "créé",
    driver_return: "Retour",
    driver_tbd: "à définir",
    driver_submit_offer: "Proposer un prix",
    driver_make_offer_title: "Faire une Offre",
    driver_make_offer_desc: "Fixez votre prix pour cette course",
    driver_your_price: "Votre Prix (EUR)",
    driver_notes_label: "Notes (optionnel)",
    driver_notes_placeholder: "ex. Bouteille d'eau incluse, siège enfant disponible...",
    driver_price_placeholder: "ex. 45",
    driver_price_suggestion: "Suggestion de Prix",
    driver_price_recommended: "recommandé",
    driver_price_range: "Fourchette",
    driver_cancel: "Annuler",
    driver_login_required: "Connexion Requise",
    driver_login_desc: "Connectez-vous pour accéder au tableau de bord chauffeur.",
    driver_login_btn: "Se Connecter",
    driver_no_profile: "Pas de Profil Chauffeur",
    driver_no_profile_desc: "Vous devez d'abord vous inscrire comme chauffeur.",
    driver_register_btn: "S'inscrire comme Chauffeur",
    driver_pending_title: "Candidature en Cours d'Examen",
    driver_pending_desc: "Votre candidature de chauffeur est en cours d'examen. Veuillez patienter.",
    driver_rejected_title: "Candidature Refusée",
    driver_rejected_desc: "Malheureusement, votre candidature a été refusée.",
    driver_complete_btn: "Terminé",
    driver_complete_confirm: "Marquer cette course comme terminée ? Le client recevra un email d'évaluation.",
    driver_complete_success: "Course terminée ! Le client a été invité à évaluer par email.",
    driver_offer_success: "Offre envoyée avec succès !",
    driver_offer_invalid_price: "Veuillez entrer un prix valide",
    driver_status_completed: "Terminé",
    driver_status_booked: "Réservé",
    driver_docs_missing_alert: "Veuillez télécharger tous les documents requis avant de continuer.",
    driver_docs_title: "Télécharger les Documents",
    driver_docs_subtitle: "Veuillez télécharger tous les documents requis",
    driver_docs_selfie: "Selfie avec Permis",
    driver_docs_registration: "Carte Grise",
    driver_docs_vehicle_photo: "Photo du Véhicule",
    driver_docs_insurance: "Attestation d'Assurance",
    driver_docs_license: "Licence de Transport (optionnel)",
    driver_docs_required: "Obligatoire",
    driver_docs_optional: "Optionnel",
    driver_docs_uploaded: "Téléchargé",
    driver_docs_camera: "Caméra",
    driver_docs_upload: "Télécharger",
    driver_docs_complete_btn: "Terminé et Continuer",
    driver_docs_btn: "Documents",
    driver_docs_incomplete: "Documents incomplets",
    driver_docs_all_complete: "Tous les documents téléchargés",
    driver_terms_accept_text: "J'accepte les",
    driver_terms_link: "Conditions Générales Chauffeur",
    driver_terms_binding_text: "Mon offre est contraignante. Je m'engage à effectuer le transfert à l'heure et au prix convenus dès que le client réserve et paie.",

    profile_settings: "Paramètres du Profil",
    profile_edit: "Modifier le Profil",
    profile_change_password: "Changer le Mot de Passe",
    profile_logout: "Déconnexion",
    profile_name: "Nom",
    profile_email: "Email",
    profile_phone: "Téléphone",
    profile_save: "Enregistrer",
    profile_cancel: "Annuler",
    profile_current_password: "Mot de Passe Actuel",
    profile_new_password: "Nouveau Mot de Passe",
    profile_confirm_password: "Confirmer le Mot de Passe",
    profile_password_mismatch: "Les mots de passe ne correspondent pas",
    profile_password_changed: "Mot de passe changé avec succès",
    profile_updated: "Profil mis à jour avec succès",
    profile_reapproval_warning: "La modification du nom, de l'email ou des données du véhicule nécessite une nouvelle approbation.",
    profile_reapproval_triggered: "Votre compte doit être réapprouvé par l'administrateur.",
    profile_vehicle_info: "Informations Véhicule",
    profile_vehicle_make: "Marque",
    profile_vehicle_model: "Modèle",
    profile_vehicle_year: "Année",
    profile_vehicle_color: "Couleur",
    profile_vehicle_plate: "Immatriculation",
    profile_vehicle_type: "Type de Véhicule",
    profile_vehicle_passengers: "Passagers",
    profile_vehicle_luggage: "Bagages",
  },

  zh: {
    nav_for_drivers: "司机入口",
    nav_for_companies: "企业入口",
    nav_driver_dashboard: "司机面板",
    nav_my_transfers: "我的接送",
    nav_admin: "管理",
    nav_login: "登录",
    nav_logout: "退出",

    auth_welcome: "欢迎回来",
    auth_register_title: "创建账户",
    auth_login_subtitle: "登录以管理您的接送服务",
    auth_register_subtitle: "为您的接送服务创建账户",
    auth_name: "全名",
    auth_email: "电子邮箱",
    auth_password: "密码",
    auth_phone: "电话号码",
    auth_login_btn: "登录",
    auth_register_btn: "创建账户",
    auth_switch_to_register: "没有账户？注册",
    auth_switch_to_login: "已有账户？登录",
    auth_fill_all: "请填写所有必填字段",
    auth_invalid: "邮箱或密码无效",

    landing_hero_title: "最优价格的机场接送",
    landing_hero_subtitle: "比较认证司机的报价，几分钟内预订您的接送服务",
    landing_from: "从哪里？",
    landing_to: "到哪里？",
    landing_search: "搜索接送",
    landing_how_it_works: "如何使用",
    landing_step1_title: "输入路线",
    landing_step1_desc: "输入上车和下车地点",
    landing_step2_title: "比较报价",
    landing_step2_desc: "接收司机的报价",
    landing_step3_title: "预订并支付",
    landing_step3_desc: "选择最佳报价",
    landing_why_title: "为什么选择366Transfer？",
    landing_get_app_title: "下载应用",
    landing_get_app_desc: "更快预订、管理您的接送服务,并直接在手机上接收推送通知。",
    landing_get_app_hint: "用手机相机扫描二维码即可直接打开应用。",
    landing_best_price: "最优价格",
    landing_best_price_desc: "比较报价，节省开支",
    landing_safe: "安全可靠",
    landing_safe_desc: "认证司机和车辆",
    landing_support: "全天候支持",
    landing_support_desc: "我们随时为您服务",
    landing_driver_cta_title: "成为366Transfer司机",
    landing_driver_cta_desc: "通过机场接送赚取收入",
    landing_driver_cta_btn: "注册成为司机",
    landing_vehicles: "我们的车型",

    booking_title: "预订接送",
    booking_vehicle: "车型",
    booking_date: "日期",
    booking_time: "时间",
    booking_flight: "航班号",
    booking_passengers: "乘客",
    booking_adults: "成人",
    booking_children: "儿童",
    booking_child_seats: "儿童座椅",
    booking_luggage: "行李",
    booking_comments: "备注",
    booking_submit: "请求接送",
    booking_login_required: "请登录以预订接送",

    dashboard_title: "我的接送",
    dashboard_subtitle: "管理您的预订并比较报价",
    dashboard_total: "总请求数",
    dashboard_with_offers: "有报价",
    dashboard_booked: "已预订",
    dashboard_login_required: "需要登录",
    dashboard_login_desc: "请登录以查看您的接送记录",
    dashboard_login_btn: "登录",
    dashboard_no_transfers: "暂无接送",
    dashboard_no_transfers_desc: "在首页预订您的第一次接送",
    dashboard_offers: "报价",
    dashboard_offers_available: "可用报价",
    dashboard_booked_driver: "已预订司机",
    dashboard_trips: "次行程",
    // auto-translated fallback, needs human review
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "银行卡",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "已付款并预订",
    dashboard_paid: "已付款",
    dashboard_status_open: "开放",
    dashboard_status_bidding: "有报价",
    dashboard_status_booked: "已预订",
    dashboard_status_cancelled: "已取消",
    dashboard_completed: "已完成",

    rating_title: "司机评价",
    rating_punctuality: "准时性",
    rating_cleanliness: "清洁度",
    rating_friendliness: "友好度",
    rating_driving_style: "驾驶风格",
    rating_comment: "评论（可选）",
    rating_submit: "提交评价",
    rating_thank_you: "谢谢！",
    rating_submitted: "您的评价已成功提交。",
    rating_overall: "总体评价",
    rating_reviews: "客户评价",

    admin_title: "管理面板",
    admin_overview: "概览",
    admin_pending: "审批",
    admin_drivers: "司机",
    admin_companies: "企业",
    admin_transfers: "接送",
    admin_payments: "支付",
    admin_users: "用户",
    admin_approve: "批准",
    admin_reject: "拒绝",
    admin_block: "封禁",
    admin_unblock: "解封",
    admin_documents: "文件",
    admin_export: "导出",
    admin_revenue: "收入",
    admin_active: "活跃",
    admin_blocked: "已封禁",
    admin_search: "搜索...",

    profile_driver: "司机资料",
    profile_company: "企业资料",
    profile_member_since: "注册时间",
    profile_trips: "次行程",
    profile_fleet: "车队",

    payment_processing: "支付处理中...",
    payment_success: "支付成功！您的预订已确认。",
    payment_cancelled: "支付已取消。您可以重试。",
    payment_error: "无法验证支付状态。",
    payment_paypal_processing: "PayPal支付处理中...",
    payment_paypal_success: "PayPal支付成功！您的预订已确认。",
    payment_paypal_error: "PayPal支付确认出错。",

    driver_title: "司机门户",
    driver_new: "新的",
    driver_my_offers: "我的报价",
    driver_offer_price: "提交报价",
    driver_requests: "新请求",
    driver_active_offers: "活跃报价",
    driver_bookings: "预订",
    driver_search: "搜索...",

    common_back: "返回",
    common_home: "首页",
    common_loading: "加载中...",
    common_error: "错误",
    common_save: "保存",
    common_cancel: "取消",
    common_delete: "删除",
    common_edit: "编辑",
    common_add: "添加",
    common_close: "关闭",
    common_confirm: "确认",
    common_persons: "人",
    common_km: "公里",
    common_min: "分钟",
    common_about: "关于我们",
    common_contact: "联系我们",
    common_language: "语言",

    company_title: "注册企业",
    company_subtitle: "运输企业车队管理",
    company_name: "企业名称",
    company_contact: "联系人",
    company_phone: "电话",
    company_region: "地区",
    company_languages: "语言",
    company_step_company: "企业",
    company_step_vehicles: "车辆",
    company_step_drivers: "司机",
    company_next_vehicles: "下一步：车辆",
    company_next_drivers: "下一步：司机",
    company_submit: "注册企业",
    company_add_vehicle: "添加车辆",
    company_add_driver: "添加司机",
    company_success: "企业已注册！",
    company_success_desc: "您的企业将由我们的团队审核。",
    company_summary: "摘要",
    company_vehicles_count: "车辆",
    company_drivers_count: "司机",

    footer_rights: "版权所有",
    footer_imprint: "法律声明",
    footer_privacy: "隐私政策",
    footer_terms: "服务条款",

    landing_bullet1: "经济价格的高端车辆",
    landing_bullet2: "即时比较司机报价",
    landing_bullet3: "安全支付：信用卡、PayPal等",
    landing_tab_transfer: "接送",
    landing_tab_hourly: "按小时",
    landing_continue: "继续",
    landing_vehicles_subtitle: "从经济型到豪华型 - 找到完美行程",
    landing_easy_payment: "便捷支付",
    landing_easy_payment_desc: "Visa、Mastercard、PayPal、Twint等",
    landing_hourly_rental: "按小时租车",

    driver_portal: "司机门户",
    driver_tab_new: "新的",
    driver_tab_vehicles: "车辆",
    driver_tab_profile: "我的资料",
    driver_tab_with_offers: "我的报价",
    driver_tab_bookings: "预订",
    driver_sort_created: "创建日期",
    driver_filter: "筛选",
    driver_search_placeholder: "搜索...",
    driver_col_id: "#",
    driver_col_ride_date: "行程日期",
    driver_col_type: "类型",
    driver_col_distance: "距离",
    driver_col_from: "从",
    driver_col_to: "到",
    driver_col_passengers: "乘客",
    driver_col_transport: "运输",
    driver_col_your_offer: "您的报价",
    driver_offered: "已报价",
    driver_offer_price_btn: "提交报价",
    driver_no_requests: "暂无可用请求",
    driver_no_bookings: "暂无预订",
    driver_new_requests: "新请求",
    driver_active_offers_count: "活跃报价",
    driver_bookings_count: "预订",
    driver_created: "创建于",
    driver_return: "返程",
    driver_tbd: "待定",
    driver_submit_offer: "提交报价",
    driver_make_offer_title: "提交报价",
    driver_make_offer_desc: "为这次行程设定您的价格",
    driver_your_price: "您的价格（欧元）",
    driver_notes_label: "备注（可选）",
    driver_notes_placeholder: "例如：含矿泉水，儿童座椅可用...",
    driver_price_placeholder: "例如：45",
    driver_price_suggestion: "价格建议",
    driver_price_recommended: "推荐",
    driver_price_range: "范围",
    driver_cancel: "取消",
    driver_login_required: "需要登录",
    driver_login_desc: "请登录以访问司机面板。",
    driver_login_btn: "登录",
    driver_no_profile: "无司机资料",
    driver_no_profile_desc: "您需要先注册成为司机。",
    driver_register_btn: "注册成为司机",
    driver_pending_title: "申请审核中",
    driver_pending_desc: "您的司机申请正在审核中，请耐心等待。",
    driver_rejected_title: "申请被拒绝",
    driver_rejected_desc: "很遗憾，您的申请已被拒绝。",
    driver_complete_btn: "已完成",
    driver_complete_confirm: "将此行程标记为已完成？客户将收到评价邮件。",
    driver_complete_success: "行程已完成！已通过邮件邀请客户评价。",
    driver_offer_success: "报价已成功发送！",
    driver_offer_invalid_price: "请输入有效价格",
    driver_status_completed: "已完成",
    driver_status_booked: "已预订",
    driver_docs_missing_alert: "请在继续之前上传所有必需文件。",
    driver_docs_title: "上传文件",
    driver_docs_subtitle: "请上传所有必需文件",
    driver_docs_selfie: "持驾照自拍",
    driver_docs_registration: "车辆登记",
    driver_docs_vehicle_photo: "车辆照片",
    driver_docs_insurance: "保险证明",
    driver_docs_license: "运输许可证（可选）",
    driver_docs_required: "必需",
    driver_docs_optional: "可选",
    driver_docs_uploaded: "已上传",
    driver_docs_camera: "拍照",
    driver_docs_upload: "上传",
    driver_docs_complete_btn: "完成并继续",
    driver_docs_btn: "文件",
    driver_docs_incomplete: "文件不完整",
    driver_docs_all_complete: "所有文件已上传",
    driver_terms_accept_text: "我接受",
    driver_terms_link: "司机条款和条件",
    driver_terms_binding_text: "我的报价具有约束力。一旦客户预订并付款，我有义务按约定的时间和价格执行接送服务。",

    profile_settings: "个人设置",
    profile_edit: "编辑资料",
    profile_change_password: "修改密码",
    profile_logout: "退出",
    profile_name: "姓名",
    profile_email: "邮箱",
    profile_phone: "电话",
    profile_save: "保存",
    profile_cancel: "取消",
    profile_current_password: "当前密码",
    profile_new_password: "新密码",
    profile_confirm_password: "确认密码",
    profile_password_mismatch: "密码不匹配",
    profile_password_changed: "密码修改成功",
    profile_updated: "资料更新成功",
    profile_reapproval_warning: "修改姓名、邮箱或车辆信息需要重新审批。",
    profile_reapproval_triggered: "您的账户需要管理员重新审批。",
    profile_vehicle_info: "车辆信息",
    profile_vehicle_make: "品牌",
    profile_vehicle_model: "型号",
    profile_vehicle_year: "年份",
    profile_vehicle_color: "颜色",
    profile_vehicle_plate: "车牌号",
    profile_vehicle_type: "车辆类型",
    profile_vehicle_passengers: "乘客数",
    profile_vehicle_luggage: "行李数",
  },

  pt: {
    nav_for_drivers: "Para Motoristas",
    nav_for_companies: "Para Empresas",
    nav_driver_dashboard: "Painel do Motorista",
    nav_my_transfers: "Meus Transfers",
    nav_admin: "Admin",
    nav_login: "Entrar",
    nav_logout: "Sair",

    auth_welcome: "Bem-vindo de volta",
    auth_register_title: "Criar Conta",
    auth_login_subtitle: "Entre para gerir os seus transfers",
    auth_register_subtitle: "Crie uma conta para o seu transfer",
    auth_name: "Nome Completo",
    auth_email: "Endereço de Email",
    auth_password: "Palavra-passe",
    auth_phone: "Número de Telefone",
    auth_login_btn: "Entrar",
    auth_register_btn: "Criar Conta",
    auth_switch_to_register: "Sem conta? Registar",
    auth_switch_to_login: "Já tem conta? Entrar",
    auth_fill_all: "Por favor, preencha todos os campos obrigatórios",
    auth_invalid: "Email ou palavra-passe inválidos",

    landing_hero_title: "Transfers Aeroporto ao Melhor Preço",
    landing_hero_subtitle: "Compare ofertas de motoristas verificados e reserve o seu transfer em minutos",
    landing_from: "De onde?",
    landing_to: "Para onde?",
    landing_search: "Pesquisar Transfer",
    landing_how_it_works: "Como Funciona",
    landing_step1_title: "Insira a Rota",
    landing_step1_desc: "Insira o local de recolha e destino",
    landing_step2_title: "Compare Ofertas",
    landing_step2_desc: "Receba ofertas de motoristas",
    landing_step3_title: "Reserve e Pague",
    landing_step3_desc: "Escolha a melhor oferta",
    landing_why_title: "Porquê 366Transfer?",
    landing_get_app_title: "Obter a app",
    landing_get_app_desc: "Reserve mais rapidamente, gerencie suas transferências e receba notificações diretamente no seu telefone.",
    landing_get_app_hint: "Digitalize o código QR com a câmara do telemóvel para abrir a app diretamente.",
    landing_best_price: "Melhor Preço",
    landing_best_price_desc: "Compare ofertas e poupe",
    landing_safe: "Seguro e Fiável",
    landing_safe_desc: "Motoristas e veículos verificados",
    landing_support: "Suporte 24/7",
    landing_support_desc: "Estamos sempre aqui para si",
    landing_driver_cta_title: "Torne-se Motorista na 366Transfer",
    landing_driver_cta_desc: "Ganhe dinheiro com transfers aeroporto",
    landing_driver_cta_btn: "Registar como Motorista",
    landing_vehicles: "As Nossas Classes de Veículos",

    booking_title: "Reservar Transfer",
    booking_vehicle: "Classe de Veículo",
    booking_date: "Data",
    booking_time: "Hora",
    booking_flight: "Número do Voo",
    booking_passengers: "Passageiros",
    booking_adults: "Adultos",
    booking_children: "Crianças",
    booking_child_seats: "Cadeiras de Criança",
    booking_luggage: "Bagagem",
    booking_comments: "Comentários",
    booking_submit: "Solicitar Transfer",
    booking_login_required: "Entre para reservar um transfer",

    dashboard_title: "Meus Transfers",
    dashboard_subtitle: "Gerir as suas reservas e comparar ofertas",
    dashboard_total: "Total de Pedidos",
    dashboard_with_offers: "Com Ofertas",
    dashboard_booked: "Reservado",
    dashboard_login_required: "Login Necessário",
    dashboard_login_desc: "Entre para ver os seus transfers",
    dashboard_login_btn: "Entrar",
    dashboard_no_transfers: "Sem Transfers",
    dashboard_no_transfers_desc: "Reserve o seu primeiro transfer na página inicial",
    dashboard_offers: "Ofertas",
    dashboard_offers_available: "Ofertas disponíveis",
    dashboard_booked_driver: "Motorista Reservado",
    dashboard_trips: "viagens",
    // auto-translated fallback, needs human review
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "Cartão",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "Pago e Reservado",
    dashboard_paid: "Pago",
    dashboard_status_open: "Aberto",
    dashboard_status_bidding: "Ofertas disponíveis",
    dashboard_status_booked: "Reservado",
    dashboard_status_cancelled: "Cancelado",
    dashboard_completed: "Concluído",

    rating_title: "Avaliação do Motorista",
    rating_punctuality: "Pontualidade",
    rating_cleanliness: "Limpeza",
    rating_friendliness: "Simpatia",
    rating_driving_style: "Estilo de Condução",
    rating_comment: "Comentário (opcional)",
    rating_submit: "Enviar Avaliação",
    rating_thank_you: "Obrigado!",
    rating_submitted: "A sua avaliação foi enviada com sucesso.",
    rating_overall: "Avaliação Geral",
    rating_reviews: "Avaliações de Clientes",

    admin_title: "Painel Admin",
    admin_overview: "Visão Geral",
    admin_pending: "Aprovações",
    admin_drivers: "Motoristas",
    admin_companies: "Empresas",
    admin_transfers: "Transfers",
    admin_payments: "Pagamentos",
    admin_users: "Utilizadores",
    admin_approve: "Aprovar",
    admin_reject: "Rejeitar",
    admin_block: "Bloquear",
    admin_unblock: "Desbloquear",
    admin_documents: "Documentos",
    admin_export: "Exportar",
    admin_revenue: "Receita",
    admin_active: "Ativo",
    admin_blocked: "Bloqueado",
    admin_search: "Pesquisar...",

    profile_driver: "Perfil do Motorista",
    profile_company: "Perfil da Empresa",
    profile_member_since: "Membro desde",
    profile_trips: "viagens",
    profile_fleet: "Frota de Veículos",

    payment_processing: "Pagamento em processamento...",
    payment_success: "Pagamento efetuado! A sua reserva está confirmada.",
    payment_cancelled: "Pagamento cancelado. Pode tentar novamente.",
    payment_error: "Não foi possível verificar o estado do pagamento.",
    payment_paypal_processing: "Pagamento PayPal em processamento...",
    payment_paypal_success: "Pagamento PayPal efetuado! A sua reserva está confirmada.",
    payment_paypal_error: "Erro na confirmação do pagamento PayPal.",

    driver_title: "Portal do Motorista",
    driver_new: "Novo",
    driver_my_offers: "As Minhas Ofertas",
    driver_offer_price: "Fazer Oferta",
    driver_requests: "novos pedidos",
    driver_active_offers: "ofertas ativas",
    driver_bookings: "reservas",
    driver_search: "Pesquisar...",

    common_back: "Voltar",
    common_home: "Início",
    common_loading: "A carregar...",
    common_error: "Erro",
    common_save: "Guardar",
    common_cancel: "Cancelar",
    common_delete: "Eliminar",
    common_edit: "Editar",
    common_add: "Adicionar",
    common_close: "Fechar",
    common_confirm: "Confirmar",
    common_persons: "pes.",
    common_km: "km",
    common_min: "min",
    common_about: "Sobre Nós",
    common_contact: "Contacto",
    common_language: "Idioma",

    company_title: "Registar Empresa",
    company_subtitle: "Gestão de frota para empresas de transporte",
    company_name: "Nome da Empresa",
    company_contact: "Pessoa de Contacto",
    company_phone: "Telefone",
    company_region: "Região",
    company_languages: "Idiomas",
    company_step_company: "Empresa",
    company_step_vehicles: "Veículos",
    company_step_drivers: "Motoristas",
    company_next_vehicles: "Seguinte: Veículos",
    company_next_drivers: "Seguinte: Motoristas",
    company_submit: "Registar Empresa",
    company_add_vehicle: "Adicionar Veículo",
    company_add_driver: "Adicionar Motorista",
    company_success: "Empresa Registada!",
    company_success_desc: "A sua empresa será verificada pela nossa equipa.",
    company_summary: "Resumo",
    company_vehicles_count: "Veículos",
    company_drivers_count: "Motoristas",

    footer_rights: "Todos os direitos reservados",
    footer_imprint: "Aviso Legal",
    footer_privacy: "Privacidade",
    footer_terms: "Termos",

    landing_bullet1: "Veículos premium a preços económicos",
    landing_bullet2: "Compare ofertas de motoristas instantaneamente",
    landing_bullet3: "Pague com segurança com cartão, PayPal e mais",
    landing_tab_transfer: "Transfer",
    landing_tab_hourly: "Por Hora",
    landing_continue: "Continuar",
    landing_vehicles_subtitle: "De Económico a Luxo - encontre a viagem perfeita",
    landing_easy_payment: "Pagamento Fácil",
    landing_easy_payment_desc: "Visa, Mastercard, PayPal, Twint e mais",
    landing_hourly_rental: "Aluguer por Hora",

    driver_portal: "Portal do Motorista",
    driver_tab_new: "Novo",
    driver_tab_vehicles: "Veículos",
    driver_tab_profile: "Meu perfil",
    driver_tab_with_offers: "Com as minhas ofertas",
    driver_tab_bookings: "Reservas",
    driver_sort_created: "Data de criação",
    driver_filter: "Filtrar",
    driver_search_placeholder: "Pesquisar...",
    driver_col_id: "#",
    driver_col_ride_date: "Data da viagem",
    driver_col_type: "Tipo",
    driver_col_distance: "Distância",
    driver_col_from: "De",
    driver_col_to: "Para",
    driver_col_passengers: "Passageiros",
    driver_col_transport: "Transporte",
    driver_col_your_offer: "A sua oferta",
    driver_offered: "Oferecido",
    driver_offer_price_btn: "Oferecer preço",
    driver_no_requests: "Sem pedidos disponíveis",
    driver_no_bookings: "Sem reservas",
    driver_new_requests: "novos pedidos",
    driver_active_offers_count: "ofertas ativas",
    driver_bookings_count: "reservas",
    driver_created: "criado",
    driver_return: "Regresso",
    driver_tbd: "a definir",
    driver_submit_offer: "Oferecer preço",
    driver_make_offer_title: "Fazer uma Oferta",
    driver_make_offer_desc: "Defina o seu preço para esta viagem",
    driver_your_price: "O Seu Preço (EUR)",
    driver_notes_label: "Notas (opcional)",
    driver_notes_placeholder: "ex. Garrafa de água incluída, cadeira de criança disponível...",
    driver_price_placeholder: "ex. 45",
    driver_price_suggestion: "Sugestão de Preço",
    driver_price_recommended: "recomendado",
    driver_price_range: "Intervalo",
    driver_cancel: "Cancelar",
    driver_login_required: "Login Necessário",
    driver_login_desc: "Entre para aceder ao painel do motorista.",
    driver_login_btn: "Entrar",
    driver_no_profile: "Sem Perfil de Motorista",
    driver_no_profile_desc: "Precisa de se registar como motorista primeiro.",
    driver_register_btn: "Registar como Motorista",
    driver_pending_title: "Candidatura em Análise",
    driver_pending_desc: "A sua candidatura de motorista está a ser analisada. Aguarde.",
    driver_rejected_title: "Candidatura Rejeitada",
    driver_rejected_desc: "Infelizmente, a sua candidatura foi rejeitada.",
    driver_complete_btn: "Concluído",
    driver_complete_confirm: "Marcar esta viagem como concluída? O cliente receberá um email de avaliação.",
    driver_complete_success: "Viagem concluída! O cliente foi convidado a avaliar por email.",
    driver_offer_success: "Oferta enviada com sucesso!",
    driver_offer_invalid_price: "Introduza um preço válido",
    driver_status_completed: "Concluído",
    driver_status_booked: "Reservado",
    driver_docs_missing_alert: "Carregue todos os documentos necessários antes de continuar.",
    driver_docs_title: "Carregar Documentos",
    driver_docs_subtitle: "Carregue todos os documentos necessários",
    driver_docs_selfie: "Selfie com Carta de Condução",
    driver_docs_registration: "Registo do Veículo",
    driver_docs_vehicle_photo: "Foto do Veículo",
    driver_docs_insurance: "Certificado de Seguro",
    driver_docs_license: "Licença de Transporte (opcional)",
    driver_docs_required: "Obrigatório",
    driver_docs_optional: "Opcional",
    driver_docs_uploaded: "Carregado",
    driver_docs_camera: "Câmara",
    driver_docs_upload: "Carregar",
    driver_docs_complete_btn: "Concluído e Continuar",
    driver_docs_btn: "Documentos",
    driver_docs_incomplete: "Documentos incompletos",
    driver_docs_all_complete: "Todos os documentos carregados",
    driver_terms_accept_text: "Aceito os",
    driver_terms_link: "Termos e Condições do Motorista",
    driver_terms_binding_text: "A minha oferta é vinculativa. Comprometo-me a realizar o transfer na hora e preço acordados assim que o cliente reservar e pagar.",

    profile_settings: "Definições do Perfil",
    profile_edit: "Editar Perfil",
    profile_change_password: "Alterar Palavra-passe",
    profile_logout: "Sair",
    profile_name: "Nome",
    profile_email: "Email",
    profile_phone: "Telefone",
    profile_save: "Guardar",
    profile_cancel: "Cancelar",
    profile_current_password: "Palavra-passe Atual",
    profile_new_password: "Nova Palavra-passe",
    profile_confirm_password: "Confirmar Palavra-passe",
    profile_password_mismatch: "As palavras-passe não coincidem",
    profile_password_changed: "Palavra-passe alterada com sucesso",
    profile_updated: "Perfil atualizado com sucesso",
    profile_reapproval_warning: "A alteração de nome, email ou dados do veículo requer nova aprovação.",
    profile_reapproval_triggered: "A sua conta precisa de ser reaprovada pelo admin.",
    profile_vehicle_info: "Informações do Veículo",
    profile_vehicle_make: "Marca",
    profile_vehicle_model: "Modelo",
    profile_vehicle_year: "Ano",
    profile_vehicle_color: "Cor",
    profile_vehicle_plate: "Matrícula",
    profile_vehicle_type: "Tipo de Veículo",
    profile_vehicle_passengers: "Passageiros",
    profile_vehicle_luggage: "Bagagem",
  },

  nl: {
    nav_for_drivers: "Voor Chauffeurs",
    nav_for_companies: "Voor Bedrijven",
    nav_driver_dashboard: "Chauffeur Dashboard",
    nav_my_transfers: "Mijn Transfers",
    nav_admin: "Admin",
    nav_login: "Inloggen",
    nav_logout: "Uitloggen",

    auth_welcome: "Welkom terug",
    auth_register_title: "Account Aanmaken",
    auth_login_subtitle: "Log in om uw transfers te beheren",
    auth_register_subtitle: "Maak een account aan voor uw transfer",
    auth_name: "Volledige Naam",
    auth_email: "E-mailadres",
    auth_password: "Wachtwoord",
    auth_phone: "Telefoonnummer",
    auth_login_btn: "Inloggen",
    auth_register_btn: "Account Aanmaken",
    auth_switch_to_register: "Geen account? Registreren",
    auth_switch_to_login: "Al een account? Inloggen",
    auth_fill_all: "Vul alle verplichte velden in",
    auth_invalid: "Ongeldig e-mailadres of wachtwoord",

    landing_hero_title: "Luchthaventransfers voor de Beste Prijs",
    landing_hero_subtitle: "Vergelijk aanbiedingen van geverifieerde chauffeurs en boek uw transfer in enkele minuten",
    landing_from: "Vanwaar?",
    landing_to: "Waarheen?",
    landing_search: "Transfer Zoeken",
    landing_how_it_works: "Hoe het Werkt",
    landing_step1_title: "Route Invoeren",
    landing_step1_desc: "Voer ophaal- en afleverlocatie in",
    landing_step2_title: "Aanbiedingen Vergelijken",
    landing_step2_desc: "Ontvang aanbiedingen van chauffeurs",
    landing_step3_title: "Boeken & Betalen",
    landing_step3_desc: "Kies het beste aanbod",
    landing_why_title: "Waarom 366Transfer?",
    landing_get_app_title: "Download de app",
    landing_get_app_desc: "Boek sneller, beheer uw transfers en ontvang pushmeldingen direct op uw telefoon.",
    landing_get_app_hint: "Scan de QR-code met uw telefooncamera om de app direct te openen.",
    landing_best_price: "Beste Prijs",
    landing_best_price_desc: "Vergelijk aanbiedingen en bespaar",
    landing_safe: "Veilig & Betrouwbaar",
    landing_safe_desc: "Geverifieerde chauffeurs en voertuigen",
    landing_support: "24/7 Ondersteuning",
    landing_support_desc: "Wij staan altijd voor u klaar",
    landing_driver_cta_title: "Word Chauffeur bij 366Transfer",
    landing_driver_cta_desc: "Verdien geld met luchthaventransfers",
    landing_driver_cta_btn: "Registreer als Chauffeur",
    landing_vehicles: "Onze Voertuigklassen",

    booking_title: "Transfer Boeken",
    booking_vehicle: "Voertuigklasse",
    booking_date: "Datum",
    booking_time: "Tijd",
    booking_flight: "Vluchtnummer",
    booking_passengers: "Passagiers",
    booking_adults: "Volwassenen",
    booking_children: "Kinderen",
    booking_child_seats: "Kinderzitjes",
    booking_luggage: "Bagage",
    booking_comments: "Opmerkingen",
    booking_submit: "Transfer Aanvragen",
    booking_login_required: "Log in om een transfer te boeken",

    dashboard_title: "Mijn Transfers",
    dashboard_subtitle: "Beheer uw boekingen en vergelijk aanbiedingen",
    dashboard_total: "Totaal Aanvragen",
    dashboard_with_offers: "Met Aanbiedingen",
    dashboard_booked: "Geboekt",
    dashboard_login_required: "Inloggen Vereist",
    dashboard_login_desc: "Log in om uw transfers te bekijken",
    dashboard_login_btn: "Inloggen",
    dashboard_no_transfers: "Geen Transfers",
    dashboard_no_transfers_desc: "Boek uw eerste transfer op de startpagina",
    dashboard_offers: "Aanbiedingen",
    dashboard_offers_available: "Aanbiedingen beschikbaar",
    dashboard_booked_driver: "Geboekte Chauffeur",
    dashboard_trips: "ritten",
    // auto-translated fallback, needs human review
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "Kaart",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "Betaald & Geboekt",
    dashboard_paid: "Betaald",
    dashboard_status_open: "Open",
    dashboard_status_bidding: "Aanbiedingen beschikbaar",
    dashboard_status_booked: "Geboekt",
    dashboard_status_cancelled: "Geannuleerd",
    dashboard_completed: "Voltooid",

    rating_title: "Chauffeursbeoordeling",
    rating_punctuality: "Stiptheid",
    rating_cleanliness: "Netheid",
    rating_friendliness: "Vriendelijkheid",
    rating_driving_style: "Rijstijl",
    rating_comment: "Opmerking (optioneel)",
    rating_submit: "Beoordeling Versturen",
    rating_thank_you: "Dank u!",
    rating_submitted: "Uw beoordeling is succesvol verzonden.",
    rating_overall: "Totaalbeoordeling",
    rating_reviews: "Klantbeoordelingen",

    admin_title: "Admin Dashboard",
    admin_overview: "Overzicht",
    admin_pending: "Goedkeuringen",
    admin_drivers: "Chauffeurs",
    admin_companies: "Bedrijven",
    admin_transfers: "Transfers",
    admin_payments: "Betalingen",
    admin_users: "Gebruikers",
    admin_approve: "Goedkeuren",
    admin_reject: "Afwijzen",
    admin_block: "Blokkeren",
    admin_unblock: "Deblokkeren",
    admin_documents: "Documenten",
    admin_export: "Exporteren",
    admin_revenue: "Omzet",
    admin_active: "Actief",
    admin_blocked: "Geblokkeerd",
    admin_search: "Zoeken...",

    profile_driver: "Chauffeursprofiel",
    profile_company: "Bedrijfsprofiel",
    profile_member_since: "Lid sinds",
    profile_trips: "ritten",
    profile_fleet: "Wagenpark",

    payment_processing: "Betaling wordt verwerkt...",
    payment_success: "Betaling geslaagd! Uw boeking is bevestigd.",
    payment_cancelled: "Betaling geannuleerd. U kunt het opnieuw proberen.",
    payment_error: "Kon de betalingsstatus niet verifiëren.",
    payment_paypal_processing: "PayPal-betaling wordt verwerkt...",
    payment_paypal_success: "PayPal-betaling geslaagd! Uw boeking is bevestigd.",
    payment_paypal_error: "Fout bij PayPal-betalingsbevestiging.",

    driver_title: "Chauffeursportaal",
    driver_new: "Nieuw",
    driver_my_offers: "Mijn Aanbiedingen",
    driver_offer_price: "Bod Uitbrengen",
    driver_requests: "nieuwe aanvragen",
    driver_active_offers: "actieve aanbiedingen",
    driver_bookings: "boekingen",
    driver_search: "Zoeken...",

    common_back: "Terug",
    common_home: "Start",
    common_loading: "Laden...",
    common_error: "Fout",
    common_save: "Opslaan",
    common_cancel: "Annuleren",
    common_delete: "Verwijderen",
    common_edit: "Bewerken",
    common_add: "Toevoegen",
    common_close: "Sluiten",
    common_confirm: "Bevestigen",
    common_persons: "pers.",
    common_km: "km",
    common_min: "min",
    common_about: "Over Ons",
    common_contact: "Contact",
    common_language: "Taal",

    company_title: "Bedrijf Registreren",
    company_subtitle: "Wagenparkbeheer voor transportbedrijven",
    company_name: "Bedrijfsnaam",
    company_contact: "Contactpersoon",
    company_phone: "Telefoon",
    company_region: "Regio",
    company_languages: "Talen",
    company_step_company: "Bedrijf",
    company_step_vehicles: "Voertuigen",
    company_step_drivers: "Chauffeurs",
    company_next_vehicles: "Volgende: Voertuigen",
    company_next_drivers: "Volgende: Chauffeurs",
    company_submit: "Bedrijf Registreren",
    company_add_vehicle: "Voertuig Toevoegen",
    company_add_driver: "Chauffeur Toevoegen",
    company_success: "Bedrijf Geregistreerd!",
    company_success_desc: "Uw bedrijf wordt door ons team beoordeeld.",
    company_summary: "Samenvatting",
    company_vehicles_count: "Voertuigen",
    company_drivers_count: "Chauffeurs",

    footer_rights: "Alle rechten voorbehouden",
    footer_imprint: "Impressum",
    footer_privacy: "Privacy",
    footer_terms: "Voorwaarden",

    landing_bullet1: "Premiumvoertuigen tegen economische prijzen",
    landing_bullet2: "Vergelijk chauffeur aanbiedingen direct",
    landing_bullet3: "Betaal veilig met creditcard, PayPal en meer",
    landing_tab_transfer: "Transfer",
    landing_tab_hourly: "Per Uur",
    landing_continue: "Doorgaan",
    landing_vehicles_subtitle: "Van Economy tot Luxe - vind de perfecte rit",
    landing_easy_payment: "Eenvoudig Betalen",
    landing_easy_payment_desc: "Visa, Mastercard, PayPal, Twint en meer",
    landing_hourly_rental: "Verhuur per Uur",

    driver_portal: "Chauffeursportaal",
    driver_tab_new: "Nieuw",
    driver_tab_vehicles: "Voertuigen",
    driver_tab_profile: "Mijn profiel",
    driver_tab_with_offers: "Met mijn aanbiedingen",
    driver_tab_bookings: "Boekingen",
    driver_sort_created: "Aanmaakdatum",
    driver_filter: "Filter",
    driver_search_placeholder: "Zoeken...",
    driver_col_id: "#",
    driver_col_ride_date: "Ritdatum",
    driver_col_type: "Type",
    driver_col_distance: "Afstand",
    driver_col_from: "Van",
    driver_col_to: "Naar",
    driver_col_passengers: "Passagiers",
    driver_col_transport: "Transport",
    driver_col_your_offer: "Uw aanbod",
    driver_offered: "Aangeboden",
    driver_offer_price_btn: "Prijs aanbieden",
    driver_no_requests: "Geen aanvragen beschikbaar",
    driver_no_bookings: "Nog geen boekingen",
    driver_new_requests: "nieuwe aanvragen",
    driver_active_offers_count: "actieve aanbiedingen",
    driver_bookings_count: "boekingen",
    driver_created: "aangemaakt",
    driver_return: "Retour",
    driver_tbd: "nader te bepalen",
    driver_submit_offer: "Prijs aanbieden",
    driver_make_offer_title: "Bod Uitbrengen",
    driver_make_offer_desc: "Stel uw prijs in voor deze rit",
    driver_your_price: "Uw Prijs (EUR)",
    driver_notes_label: "Notities (optioneel)",
    driver_notes_placeholder: "bijv. Fles water inbegrepen, kinderzitje beschikbaar...",
    driver_price_placeholder: "bijv. 45",
    driver_price_suggestion: "Prijssuggestie",
    driver_price_recommended: "aanbevolen",
    driver_price_range: "Bereik",
    driver_cancel: "Annuleren",
    driver_login_required: "Inloggen Vereist",
    driver_login_desc: "Log in om het chauffeursdashboard te openen.",
    driver_login_btn: "Inloggen",
    driver_no_profile: "Geen Chauffeursprofiel",
    driver_no_profile_desc: "U moet zich eerst als chauffeur registreren.",
    driver_register_btn: "Registreer als Chauffeur",
    driver_pending_title: "Aanvraag in Behandeling",
    driver_pending_desc: "Uw chauffeursaanvraag wordt beoordeeld. Even geduld.",
    driver_rejected_title: "Aanvraag Afgewezen",
    driver_rejected_desc: "Helaas is uw aanvraag afgewezen.",
    driver_complete_btn: "Voltooid",
    driver_complete_confirm: "Deze rit als voltooid markeren? De klant ontvangt een beoordelingsmail.",
    driver_complete_success: "Rit voltooid! De klant is uitgenodigd om te beoordelen per e-mail.",
    driver_offer_success: "Aanbod succesvol verzonden!",
    driver_offer_invalid_price: "Voer een geldige prijs in",
    driver_status_completed: "Voltooid",
    driver_status_booked: "Geboekt",
    driver_docs_missing_alert: "Upload alle vereiste documenten voordat u doorgaat.",
    driver_docs_title: "Documenten Uploaden",
    driver_docs_subtitle: "Upload alle vereiste documenten",
    driver_docs_selfie: "Selfie met Rijbewijs",
    driver_docs_registration: "Voertuigregistratie",
    driver_docs_vehicle_photo: "Voertuigfoto",
    driver_docs_insurance: "Verzekeringsbewijs",
    driver_docs_license: "Transportvergunning (optioneel)",
    driver_docs_required: "Verplicht",
    driver_docs_optional: "Optioneel",
    driver_docs_uploaded: "Geüpload",
    driver_docs_camera: "Camera",
    driver_docs_upload: "Uploaden",
    driver_docs_complete_btn: "Klaar & Doorgaan",
    driver_docs_btn: "Documenten",
    driver_docs_incomplete: "Documenten onvolledig",
    driver_docs_all_complete: "Alle documenten geüpload",
    driver_terms_accept_text: "Ik accepteer de",
    driver_terms_link: "Algemene Voorwaarden voor Chauffeurs",
    driver_terms_binding_text: "Mijn aanbod is bindend. Ik ben verplicht de transfer uit te voeren op de afgesproken tijd en prijs zodra de klant boekt en betaalt.",

    profile_settings: "Profielinstellingen",
    profile_edit: "Profiel Bewerken",
    profile_change_password: "Wachtwoord Wijzigen",
    profile_logout: "Uitloggen",
    profile_name: "Naam",
    profile_email: "E-mail",
    profile_phone: "Telefoon",
    profile_save: "Opslaan",
    profile_cancel: "Annuleren",
    profile_current_password: "Huidig Wachtwoord",
    profile_new_password: "Nieuw Wachtwoord",
    profile_confirm_password: "Wachtwoord Bevestigen",
    profile_password_mismatch: "Wachtwoorden komen niet overeen",
    profile_password_changed: "Wachtwoord succesvol gewijzigd",
    profile_updated: "Profiel succesvol bijgewerkt",
    profile_reapproval_warning: "Het wijzigen van naam, e-mail of voertuiggegevens vereist hernieuwde goedkeuring.",
    profile_reapproval_triggered: "Uw account moet opnieuw worden goedgekeurd door de admin.",
    profile_vehicle_info: "Voertuiggegevens",
    profile_vehicle_make: "Merk",
    profile_vehicle_model: "Model",
    profile_vehicle_year: "Bouwjaar",
    profile_vehicle_color: "Kleur",
    profile_vehicle_plate: "Kenteken",
    profile_vehicle_type: "Voertuigtype",
    profile_vehicle_passengers: "Passagiers",
    profile_vehicle_luggage: "Bagage",
  },

  es: {
    nav_for_drivers: "Para Conductores",
    nav_for_companies: "Para Empresas",
    nav_driver_dashboard: "Panel del Conductor",
    nav_my_transfers: "Mis Transfers",
    nav_admin: "Admin",
    nav_login: "Iniciar Sesión",
    nav_logout: "Cerrar Sesión",

    auth_welcome: "Bienvenido de nuevo",
    auth_register_title: "Crear Cuenta",
    auth_login_subtitle: "Inicie sesión para gestionar sus transfers",
    auth_register_subtitle: "Cree una cuenta para su transfer",
    auth_name: "Nombre Completo",
    auth_email: "Correo Electrónico",
    auth_password: "Contraseña",
    auth_phone: "Número de Teléfono",
    auth_login_btn: "Iniciar Sesión",
    auth_register_btn: "Crear Cuenta",
    auth_switch_to_register: "¿Sin cuenta? Regístrese",
    auth_switch_to_login: "¿Ya tiene cuenta? Iniciar Sesión",
    auth_fill_all: "Por favor, complete todos los campos obligatorios",
    auth_invalid: "Correo o contraseña inválidos",

    landing_hero_title: "Transfers Aeropuerto al Mejor Precio",
    landing_hero_subtitle: "Compare ofertas de conductores verificados y reserve su transfer en minutos",
    landing_from: "¿Desde dónde?",
    landing_to: "¿A dónde?",
    landing_search: "Buscar Transfer",
    landing_how_it_works: "Cómo Funciona",
    landing_step1_title: "Ingrese la Ruta",
    landing_step1_desc: "Ingrese el punto de recogida y destino",
    landing_step2_title: "Compare Ofertas",
    landing_step2_desc: "Reciba ofertas de conductores",
    landing_step3_title: "Reserve y Pague",
    landing_step3_desc: "Elija la mejor oferta",
    landing_why_title: "¿Por qué 366Transfer?",
    landing_get_app_title: "Obtén la app",
    landing_get_app_desc: "Reserva más rápido, gestiona tus traslados y recibe notificaciones directamente en tu teléfono.",
    landing_get_app_hint: "Escanea el código QR con la cámara de tu teléfono para abrir la app directamente.",
    landing_best_price: "Mejor Precio",
    landing_best_price_desc: "Compare ofertas y ahorre",
    landing_safe: "Seguro y Confiable",
    landing_safe_desc: "Conductores y vehículos verificados",
    landing_support: "Soporte 24/7",
    landing_support_desc: "Siempre estamos aquí para usted",
    landing_driver_cta_title: "Conviértase en Conductor de 366Transfer",
    landing_driver_cta_desc: "Gane dinero con transfers de aeropuerto",
    landing_driver_cta_btn: "Registrarse como Conductor",
    landing_vehicles: "Nuestras Clases de Vehículos",

    booking_title: "Reservar Transfer",
    booking_vehicle: "Clase de Vehículo",
    booking_date: "Fecha",
    booking_time: "Hora",
    booking_flight: "Número de Vuelo",
    booking_passengers: "Pasajeros",
    booking_adults: "Adultos",
    booking_children: "Niños",
    booking_child_seats: "Sillas Infantiles",
    booking_luggage: "Equipaje",
    booking_comments: "Comentarios",
    booking_submit: "Solicitar Transfer",
    booking_login_required: "Inicie sesión para reservar un transfer",

    dashboard_title: "Mis Transfers",
    dashboard_subtitle: "Gestione sus reservas y compare ofertas",
    dashboard_total: "Total de Solicitudes",
    dashboard_with_offers: "Con Ofertas",
    dashboard_booked: "Reservado",
    dashboard_login_required: "Inicio de Sesión Requerido",
    dashboard_login_desc: "Inicie sesión para ver sus transfers",
    dashboard_login_btn: "Iniciar Sesión",
    dashboard_no_transfers: "Sin Transfers",
    dashboard_no_transfers_desc: "Reserve su primer transfer en la página principal",
    dashboard_offers: "Ofertas",
    dashboard_offers_available: "Ofertas disponibles",
    dashboard_booked_driver: "Conductor Reservado",
    dashboard_trips: "viajes",
    // auto-translated fallback, needs human review
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "Tarjeta",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "Pagado y Reservado",
    dashboard_paid: "Pagado",
    dashboard_status_open: "Abierto",
    dashboard_status_bidding: "Ofertas disponibles",
    dashboard_status_booked: "Reservado",
    dashboard_status_cancelled: "Cancelado",
    dashboard_completed: "Completado",

    rating_title: "Calificación del Conductor",
    rating_punctuality: "Puntualidad",
    rating_cleanliness: "Limpieza",
    rating_friendliness: "Amabilidad",
    rating_driving_style: "Estilo de Conducción",
    rating_comment: "Comentario (opcional)",
    rating_submit: "Enviar Calificación",
    rating_thank_you: "¡Gracias!",
    rating_submitted: "Su calificación se ha enviado correctamente.",
    rating_overall: "Calificación General",
    rating_reviews: "Opiniones de Clientes",

    admin_title: "Panel Admin",
    admin_overview: "Resumen",
    admin_pending: "Aprobaciones",
    admin_drivers: "Conductores",
    admin_companies: "Empresas",
    admin_transfers: "Transfers",
    admin_payments: "Pagos",
    admin_users: "Usuarios",
    admin_approve: "Aprobar",
    admin_reject: "Rechazar",
    admin_block: "Bloquear",
    admin_unblock: "Desbloquear",
    admin_documents: "Documentos",
    admin_export: "Exportar",
    admin_revenue: "Ingresos",
    admin_active: "Activo",
    admin_blocked: "Bloqueado",
    admin_search: "Buscar...",

    profile_driver: "Perfil del Conductor",
    profile_company: "Perfil de Empresa",
    profile_member_since: "Miembro desde",
    profile_trips: "viajes",
    profile_fleet: "Flota de Vehículos",

    payment_processing: "Procesando pago...",
    payment_success: "¡Pago exitoso! Su reserva está confirmada.",
    payment_cancelled: "Pago cancelado. Puede intentarlo de nuevo.",
    payment_error: "No se pudo verificar el estado del pago.",
    payment_paypal_processing: "Procesando pago PayPal...",
    payment_paypal_success: "¡Pago PayPal exitoso! Su reserva está confirmada.",
    payment_paypal_error: "Error en la confirmación del pago PayPal.",

    driver_title: "Portal del Conductor",
    driver_new: "Nuevo",
    driver_my_offers: "Mis Ofertas",
    driver_offer_price: "Hacer Oferta",
    driver_requests: "nuevas solicitudes",
    driver_active_offers: "ofertas activas",
    driver_bookings: "reservas",
    driver_search: "Buscar...",

    common_back: "Volver",
    common_home: "Inicio",
    common_loading: "Cargando...",
    common_error: "Error",
    common_save: "Guardar",
    common_cancel: "Cancelar",
    common_delete: "Eliminar",
    common_edit: "Editar",
    common_add: "Añadir",
    common_close: "Cerrar",
    common_confirm: "Confirmar",
    common_persons: "pers.",
    common_km: "km",
    common_min: "min",
    common_about: "Sobre Nosotros",
    common_contact: "Contacto",
    common_language: "Idioma",

    company_title: "Registrar Empresa",
    company_subtitle: "Gestión de flota para empresas de transporte",
    company_name: "Nombre de la Empresa",
    company_contact: "Persona de Contacto",
    company_phone: "Teléfono",
    company_region: "Región",
    company_languages: "Idiomas",
    company_step_company: "Empresa",
    company_step_vehicles: "Vehículos",
    company_step_drivers: "Conductores",
    company_next_vehicles: "Siguiente: Vehículos",
    company_next_drivers: "Siguiente: Conductores",
    company_submit: "Registrar Empresa",
    company_add_vehicle: "Añadir Vehículo",
    company_add_driver: "Añadir Conductor",
    company_success: "¡Empresa Registrada!",
    company_success_desc: "Su empresa será verificada por nuestro equipo.",
    company_summary: "Resumen",
    company_vehicles_count: "Vehículos",
    company_drivers_count: "Conductores",

    footer_rights: "Todos los derechos reservados",
    footer_imprint: "Aviso Legal",
    footer_privacy: "Privacidad",
    footer_terms: "Términos",

    landing_bullet1: "Vehículos premium a precios económicos",
    landing_bullet2: "Compare ofertas de conductores al instante",
    landing_bullet3: "Pague de forma segura con tarjeta, PayPal y más",
    landing_tab_transfer: "Transfer",
    landing_tab_hourly: "Por Hora",
    landing_continue: "Continuar",
    landing_vehicles_subtitle: "De Económico a Lujo - encuentre el viaje perfecto",
    landing_easy_payment: "Pago Fácil",
    landing_easy_payment_desc: "Visa, Mastercard, PayPal, Twint y más",
    landing_hourly_rental: "Alquiler por Hora",

    driver_portal: "Portal del Conductor",
    driver_tab_new: "Nuevo",
    driver_tab_vehicles: "Vehículos",
    driver_tab_profile: "Mi perfil",
    driver_tab_with_offers: "Con mis ofertas",
    driver_tab_bookings: "Reservas",
    driver_sort_created: "Fecha de creación",
    driver_filter: "Filtrar",
    driver_search_placeholder: "Buscar...",
    driver_col_id: "#",
    driver_col_ride_date: "Fecha del viaje",
    driver_col_type: "Tipo",
    driver_col_distance: "Distancia",
    driver_col_from: "Desde",
    driver_col_to: "Hasta",
    driver_col_passengers: "Pasajeros",
    driver_col_transport: "Transporte",
    driver_col_your_offer: "Su oferta",
    driver_offered: "Ofertado",
    driver_offer_price_btn: "Ofrecer precio",
    driver_no_requests: "Sin solicitudes disponibles",
    driver_no_bookings: "Sin reservas aún",
    driver_new_requests: "nuevas solicitudes",
    driver_active_offers_count: "ofertas activas",
    driver_bookings_count: "reservas",
    driver_created: "creado",
    driver_return: "Regreso",
    driver_tbd: "por definir",
    driver_submit_offer: "Ofrecer precio",
    driver_make_offer_title: "Hacer una Oferta",
    driver_make_offer_desc: "Establezca su precio para este viaje",
    driver_your_price: "Su Precio (EUR)",
    driver_notes_label: "Notas (opcional)",
    driver_notes_placeholder: "ej. Botella de agua incluida, silla infantil disponible...",
    driver_price_placeholder: "ej. 45",
    driver_price_suggestion: "Sugerencia de Precio",
    driver_price_recommended: "recomendado",
    driver_price_range: "Rango",
    driver_cancel: "Cancelar",
    driver_login_required: "Inicio de Sesión Requerido",
    driver_login_desc: "Inicie sesión para acceder al panel del conductor.",
    driver_login_btn: "Iniciar Sesión",
    driver_no_profile: "Sin Perfil de Conductor",
    driver_no_profile_desc: "Primero debe registrarse como conductor.",
    driver_register_btn: "Registrarse como Conductor",
    driver_pending_title: "Solicitud en Revisión",
    driver_pending_desc: "Su solicitud de conductor está siendo revisada. Espere por favor.",
    driver_rejected_title: "Solicitud Rechazada",
    driver_rejected_desc: "Lamentablemente, su solicitud fue rechazada.",
    driver_complete_btn: "Completado",
    driver_complete_confirm: "¿Marcar este viaje como completado? El cliente recibirá un correo de calificación.",
    driver_complete_success: "¡Viaje completado! El cliente fue invitado a calificar por correo.",
    driver_offer_success: "¡Oferta enviada con éxito!",
    driver_offer_invalid_price: "Ingrese un precio válido",
    driver_status_completed: "Completado",
    driver_status_booked: "Reservado",
    driver_docs_missing_alert: "Cargue todos los documentos requeridos antes de continuar.",
    driver_docs_title: "Cargar Documentos",
    driver_docs_subtitle: "Cargue todos los documentos requeridos",
    driver_docs_selfie: "Selfie con Licencia",
    driver_docs_registration: "Registro del Vehículo",
    driver_docs_vehicle_photo: "Foto del Vehículo",
    driver_docs_insurance: "Certificado de Seguro",
    driver_docs_license: "Licencia de Transporte (opcional)",
    driver_docs_required: "Obligatorio",
    driver_docs_optional: "Opcional",
    driver_docs_uploaded: "Cargado",
    driver_docs_camera: "Cámara",
    driver_docs_upload: "Cargar",
    driver_docs_complete_btn: "Listo y Continuar",
    driver_docs_btn: "Documentos",
    driver_docs_incomplete: "Documentos incompletos",
    driver_docs_all_complete: "Todos los documentos cargados",
    driver_terms_accept_text: "Acepto los",
    driver_terms_link: "Términos y Condiciones del Conductor",
    driver_terms_binding_text: "Mi oferta es vinculante. Me comprometo a realizar el transfer en el horario y precio acordados una vez que el cliente reserve y pague.",

    profile_settings: "Configuración del Perfil",
    profile_edit: "Editar Perfil",
    profile_change_password: "Cambiar Contraseña",
    profile_logout: "Cerrar Sesión",
    profile_name: "Nombre",
    profile_email: "Correo",
    profile_phone: "Teléfono",
    profile_save: "Guardar",
    profile_cancel: "Cancelar",
    profile_current_password: "Contraseña Actual",
    profile_new_password: "Nueva Contraseña",
    profile_confirm_password: "Confirmar Contraseña",
    profile_password_mismatch: "Las contraseñas no coinciden",
    profile_password_changed: "Contraseña cambiada con éxito",
    profile_updated: "Perfil actualizado con éxito",
    profile_reapproval_warning: "Cambiar nombre, correo o datos del vehículo requiere nueva aprobación.",
    profile_reapproval_triggered: "Su cuenta necesita ser reaprobada por el admin.",
    profile_vehicle_info: "Información del Vehículo",
    profile_vehicle_make: "Marca",
    profile_vehicle_model: "Modelo",
    profile_vehicle_year: "Año",
    profile_vehicle_color: "Color",
    profile_vehicle_plate: "Matrícula",
    profile_vehicle_type: "Tipo de Vehículo",
    profile_vehicle_passengers: "Pasajeros",
    profile_vehicle_luggage: "Equipaje",
  },

  sv: {
    nav_for_drivers: "För Förare",
    nav_for_companies: "För Företag",
    nav_driver_dashboard: "Förarpanel",
    nav_my_transfers: "Mina Transfers",
    nav_admin: "Admin",
    nav_login: "Logga In",
    nav_logout: "Logga Ut",

    auth_welcome: "Välkommen tillbaka",
    auth_register_title: "Skapa Konto",
    auth_login_subtitle: "Logga in för att hantera dina transfers",
    auth_register_subtitle: "Skapa ett konto för din transfer",
    auth_name: "Fullständigt Namn",
    auth_email: "E-postadress",
    auth_password: "Lösenord",
    auth_phone: "Telefonnummer",
    auth_login_btn: "Logga In",
    auth_register_btn: "Skapa Konto",
    auth_switch_to_register: "Inget konto? Registrera",
    auth_switch_to_login: "Har redan konto? Logga In",
    auth_fill_all: "Vänligen fyll i alla obligatoriska fält",
    auth_invalid: "Ogiltig e-post eller lösenord",

    landing_hero_title: "Flygplatstransfers till Bästa Pris",
    landing_hero_subtitle: "Jämför erbjudanden från verifierade förare och boka din transfer på några minuter",
    landing_from: "Varifrån?",
    landing_to: "Vart?",
    landing_search: "Sök Transfer",
    landing_how_it_works: "Så Fungerar Det",
    landing_step1_title: "Ange Rutt",
    landing_step1_desc: "Ange hämtnings- och avlämningsplats",
    landing_step2_title: "Jämför Erbjudanden",
    landing_step2_desc: "Få erbjudanden från förare",
    landing_step3_title: "Boka & Betala",
    landing_step3_desc: "Välj det bästa erbjudandet",
    landing_why_title: "Varför 366Transfer?",
    landing_best_price: "Bästa Pris",
    landing_best_price_desc: "Jämför erbjudanden och spara",
    landing_safe: "Säkert & Pålitligt",
    landing_safe_desc: "Verifierade förare och fordon",
    landing_support: "Support Dygnet Runt",
    landing_support_desc: "Vi finns alltid här för dig",
    landing_driver_cta_title: "Bli Förare hos 366Transfer",
    landing_driver_cta_desc: "Tjäna pengar på flygplatstransfers",
    landing_driver_cta_btn: "Registrera som Förare",
    landing_vehicles: "Våra Fordonsklasser",

    booking_title: "Boka Transfer",
    booking_vehicle: "Fordonsklass",
    booking_date: "Datum",
    booking_time: "Tid",
    booking_flight: "Flightnummer",
    booking_passengers: "Passagerare",
    booking_adults: "Vuxna",
    booking_children: "Barn",
    booking_child_seats: "Barnstolar",
    booking_luggage: "Bagage",
    booking_comments: "Kommentarer",
    booking_submit: "Begär Transfer",
    booking_login_required: "Logga in för att boka en transfer",

    dashboard_title: "Mina Transfers",
    dashboard_subtitle: "Hantera dina bokningar och jämför erbjudanden",
    dashboard_total: "Totala Förfrågningar",
    dashboard_with_offers: "Med Erbjudanden",
    dashboard_booked: "Bokad",
    dashboard_login_required: "Inloggning Krävs",
    dashboard_login_desc: "Logga in för att se dina transfers",
    dashboard_login_btn: "Logga In",
    dashboard_no_transfers: "Inga Transfers",
    dashboard_no_transfers_desc: "Boka din första transfer på startsidan",
    dashboard_offers: "Erbjudanden",
    dashboard_offers_available: "Erbjudanden tillgängliga",
    dashboard_booked_driver: "Bokad Förare",
    dashboard_trips: "resor",
    // auto-translated fallback, needs human review
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "Kort",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "Betald & Bokad",
    dashboard_paid: "Betald",
    dashboard_status_open: "Öppen",
    dashboard_status_bidding: "Erbjudanden tillgängliga",
    dashboard_status_booked: "Bokad",
    dashboard_status_cancelled: "Avbokad",
    dashboard_completed: "Slutförd",

    rating_title: "Förarbetyg",
    rating_punctuality: "Punktlighet",
    rating_cleanliness: "Renlighet",
    rating_friendliness: "Vänlighet",
    rating_driving_style: "Körstil",
    rating_comment: "Kommentar (valfritt)",
    rating_submit: "Skicka Betyg",
    rating_thank_you: "Tack!",
    rating_submitted: "Ditt betyg har skickats.",
    rating_overall: "Totalbetyg",
    rating_reviews: "Kundrecensioner",

    admin_title: "Adminpanel",
    admin_overview: "Översikt",
    admin_pending: "Godkännanden",
    admin_drivers: "Förare",
    admin_companies: "Företag",
    admin_transfers: "Transfers",
    admin_payments: "Betalningar",
    admin_users: "Användare",
    admin_approve: "Godkänn",
    admin_reject: "Avvisa",
    admin_block: "Blockera",
    admin_unblock: "Avblockera",
    admin_documents: "Dokument",
    admin_export: "Exportera",
    admin_revenue: "Intäkter",
    admin_active: "Aktiv",
    admin_blocked: "Blockerad",
    admin_search: "Sök...",

    profile_driver: "Förarprofil",
    profile_company: "Företagsprofil",
    profile_member_since: "Medlem sedan",
    profile_trips: "resor",
    profile_fleet: "Fordonsflotta",

    payment_processing: "Betalning behandlas...",
    payment_success: "Betalning lyckades! Din bokning är bekräftad.",
    payment_cancelled: "Betalning avbruten. Du kan försöka igen.",
    payment_error: "Kunde inte verifiera betalningsstatus.",
    payment_paypal_processing: "PayPal-betalning behandlas...",
    payment_paypal_success: "PayPal-betalning lyckades! Din bokning är bekräftad.",
    payment_paypal_error: "Fel vid PayPal-betalningsbekräftelse.",

    driver_title: "Förarportal",
    driver_new: "Ny",
    driver_my_offers: "Mina Erbjudanden",
    driver_offer_price: "Ge Erbjudande",
    driver_requests: "nya förfrågningar",
    driver_active_offers: "aktiva erbjudanden",
    driver_bookings: "bokningar",
    driver_search: "Sök...",

    common_back: "Tillbaka",
    common_home: "Hem",
    common_loading: "Laddar...",
    common_error: "Fel",
    common_save: "Spara",
    common_cancel: "Avbryt",
    common_delete: "Radera",
    common_edit: "Redigera",
    common_add: "Lägg till",
    common_close: "Stäng",
    common_confirm: "Bekräfta",
    common_persons: "pers.",
    common_km: "km",
    common_min: "min",
    common_about: "Om Oss",
    common_contact: "Kontakt",
    common_language: "Språk",

    company_title: "Registrera Företag",
    company_subtitle: "Fordonshantering för transportföretag",
    company_name: "Företagsnamn",
    company_contact: "Kontaktperson",
    company_phone: "Telefon",
    company_region: "Region",
    company_languages: "Språk",
    company_step_company: "Företag",
    company_step_vehicles: "Fordon",
    company_step_drivers: "Förare",
    company_next_vehicles: "Nästa: Fordon",
    company_next_drivers: "Nästa: Förare",
    company_submit: "Registrera Företag",
    company_add_vehicle: "Lägg till Fordon",
    company_add_driver: "Lägg till Förare",
    company_success: "Företag Registrerat!",
    company_success_desc: "Ditt företag kommer att granskas av vårt team.",
    company_summary: "Sammanfattning",
    company_vehicles_count: "Fordon",
    company_drivers_count: "Förare",

    footer_rights: "Alla rättigheter förbehållna",
    footer_imprint: "Impressum",
    footer_privacy: "Integritet",
    footer_terms: "Villkor",

    landing_bullet1: "Premiumfordon till ekonomipriser",
    landing_bullet2: "Jämför förares erbjudanden direkt",
    landing_bullet3: "Betala säkert med kort, PayPal och mer",
    landing_tab_transfer: "Transfer",
    landing_tab_hourly: "Timvis",
    landing_continue: "Fortsätt",
    landing_vehicles_subtitle: "Från Ekonomi till Lyx - hitta den perfekta resan",
    landing_easy_payment: "Enkel Betalning",
    landing_easy_payment_desc: "Visa, Mastercard, PayPal, Twint och mer",
    landing_hourly_rental: "Timuthyrning",

    driver_portal: "Förarportal",
    driver_tab_new: "Ny",
    driver_tab_vehicles: "Køretøjer",
    driver_tab_profile: "Min profil",
    driver_tab_with_offers: "Med mina erbjudanden",
    driver_tab_bookings: "Bokningar",
    driver_sort_created: "Skapad",
    driver_filter: "Filter",
    driver_search_placeholder: "Sök...",
    driver_col_id: "#",
    driver_col_ride_date: "Resedatum",
    driver_col_type: "Typ",
    driver_col_distance: "Avstånd",
    driver_col_from: "Från",
    driver_col_to: "Till",
    driver_col_passengers: "Passagerare",
    driver_col_transport: "Transport",
    driver_col_your_offer: "Ditt erbjudande",
    driver_offered: "Erbjudet",
    driver_offer_price_btn: "Erbjud pris",
    driver_no_requests: "Inga förfrågningar tillgängliga",
    driver_no_bookings: "Inga bokningar ännu",
    driver_new_requests: "nya förfrågningar",
    driver_active_offers_count: "aktiva erbjudanden",
    driver_bookings_count: "bokningar",
    driver_created: "skapad",
    driver_return: "Retur",
    driver_tbd: "ej bestämt",
    driver_submit_offer: "Erbjud pris",
    driver_make_offer_title: "Ge ett Erbjudande",
    driver_make_offer_desc: "Ange ditt pris för denna resa",
    driver_your_price: "Ditt Pris (EUR)",
    driver_notes_label: "Anteckningar (valfritt)",
    driver_notes_placeholder: "t.ex. Vattenflaska inkluderad, barnstol tillgänglig...",
    driver_price_placeholder: "t.ex. 45",
    driver_price_suggestion: "Prisförslag",
    driver_price_recommended: "rekommenderat",
    driver_price_range: "Intervall",
    driver_cancel: "Avbryt",
    driver_login_required: "Inloggning Krävs",
    driver_login_desc: "Logga in för att komma åt förarpanelen.",
    driver_login_btn: "Logga In",
    driver_no_profile: "Ingen Förarprofil",
    driver_no_profile_desc: "Du måste registrera dig som förare först.",
    driver_register_btn: "Registrera som Förare",
    driver_pending_title: "Ansökan Under Granskning",
    driver_pending_desc: "Din föraransökan granskas. Ha tålamod.",
    driver_rejected_title: "Ansökan Avvisad",
    driver_rejected_desc: "Tyvärr avvisades din ansökan.",
    driver_complete_btn: "Slutförd",
    driver_complete_confirm: "Markera denna resa som slutförd? Kunden får ett betygsmail.",
    driver_complete_success: "Resa slutförd! Kunden bjöds in att betygsätta via e-post.",
    driver_offer_success: "Erbjudande skickat!",
    driver_offer_invalid_price: "Ange ett giltigt pris",
    driver_status_completed: "Slutförd",
    driver_status_booked: "Bokad",
    driver_docs_missing_alert: "Ladda upp alla nödvändiga dokument innan du fortsätter.",
    driver_docs_title: "Ladda upp Dokument",
    driver_docs_subtitle: "Ladda upp alla nödvändiga dokument",
    driver_docs_selfie: "Selfie med Körkort",
    driver_docs_registration: "Fordonsregistrering",
    driver_docs_vehicle_photo: "Fordonsfoto",
    driver_docs_insurance: "Försäkringsbevis",
    driver_docs_license: "Transportlicens (valfritt)",
    driver_docs_required: "Obligatoriskt",
    driver_docs_optional: "Valfritt",
    driver_docs_uploaded: "Uppladdat",
    driver_docs_camera: "Kamera",
    driver_docs_upload: "Ladda upp",
    driver_docs_complete_btn: "Klar & Fortsätt",
    driver_docs_btn: "Dokument",
    driver_docs_incomplete: "Dokument ofullständiga",
    driver_docs_all_complete: "Alla dokument uppladdade",
    driver_terms_accept_text: "Jag accepterar",
    driver_terms_link: "Förarvillkor",
    driver_terms_binding_text: "Mitt erbjudande är bindande. Jag är skyldig att utföra transporten vid överenskommen tid och pris när kunden bokar och betalar.",

    profile_settings: "Profilinställningar",
    profile_edit: "Redigera Profil",
    profile_change_password: "Ändra Lösenord",
    profile_logout: "Logga Ut",
    profile_name: "Namn",
    profile_email: "E-post",
    profile_phone: "Telefon",
    profile_save: "Spara",
    profile_cancel: "Avbryt",
    profile_current_password: "Nuvarande Lösenord",
    profile_new_password: "Nytt Lösenord",
    profile_confirm_password: "Bekräfta Lösenord",
    profile_password_mismatch: "Lösenorden matchar inte",
    profile_password_changed: "Lösenord ändrat",
    profile_updated: "Profil uppdaterad",
    profile_reapproval_warning: "Ändring av namn, e-post eller fordonsdata kräver nytt godkännande.",
    profile_reapproval_triggered: "Ditt konto behöver godkännas på nytt av admin.",
    profile_vehicle_info: "Fordonsuppgifter",
    profile_vehicle_make: "Märke",
    profile_vehicle_model: "Modell",
    profile_vehicle_year: "Årsmodell",
    profile_vehicle_color: "Färg",
    profile_vehicle_plate: "Registreringsnummer",
    profile_vehicle_type: "Fordonstyp",
    profile_vehicle_passengers: "Passagerare",
    profile_vehicle_luggage: "Bagage",
  },

  tr: {
    nav_for_drivers: "Sürücüler İçin",
    nav_for_companies: "Şirketler İçin",
    nav_driver_dashboard: "Sürücü Paneli",
    nav_my_transfers: "Transferlerim",
    nav_admin: "Yönetici",
    nav_login: "Giriş Yap",
    nav_logout: "Çıkış Yap",

    auth_welcome: "Tekrar hoş geldiniz",
    auth_register_title: "Hesap Oluştur",
    auth_login_subtitle: "Transferlerinizi yönetmek için giriş yapın",
    auth_register_subtitle: "Transferiniz için hesap oluşturun",
    auth_name: "Ad Soyad",
    auth_email: "E-posta Adresi",
    auth_password: "Şifre",
    auth_phone: "Telefon Numarası",
    auth_login_btn: "Giriş Yap",
    auth_register_btn: "Hesap Oluştur",
    auth_switch_to_register: "Hesabınız yok mu? Kayıt olun",
    auth_switch_to_login: "Zaten hesabınız var mı? Giriş yapın",
    auth_fill_all: "Lütfen tüm zorunlu alanları doldurun",
    auth_invalid: "Geçersiz e-posta veya şifre",

    landing_hero_title: "En İyi Fiyata Havalimanı Transferi",
    landing_hero_subtitle: "Onaylı sürücülerin tekliflerini karşılaştırın ve transferinizi dakikalar içinde rezerve edin",
    landing_from: "Nereden?",
    landing_to: "Nereye?",
    landing_search: "Transfer Ara",
    landing_how_it_works: "Nasıl Çalışır",
    landing_step1_title: "Rota Girin",
    landing_step1_desc: "Alış ve varış noktasını girin",
    landing_step2_title: "Teklifleri Karşılaştırın",
    landing_step2_desc: "Sürücülerden teklif alın",
    landing_step3_title: "Rezerve Edin ve Ödeyin",
    landing_step3_desc: "En iyi teklifi seçin",
    landing_why_title: "Neden 366Transfer?",
    landing_best_price: "En İyi Fiyat",
    landing_best_price_desc: "Teklifleri karşılaştırın ve tasarruf edin",
    landing_safe: "Güvenli ve Güvenilir",
    landing_safe_desc: "Onaylı sürücüler ve araçlar",
    landing_support: "7/24 Destek",
    landing_support_desc: "Her zaman yanınızdayız",
    landing_driver_cta_title: "366Transfer'de Sürücü Olun",
    landing_driver_cta_desc: "Havalimanı transferleriyle para kazanın",
    landing_driver_cta_btn: "Sürücü Olarak Kaydol",
    landing_vehicles: "Araç Sınıflarımız",

    booking_title: "Transfer Rezervasyonu",
    booking_vehicle: "Araç Sınıfı",
    booking_date: "Tarih",
    booking_time: "Saat",
    booking_flight: "Uçuş Numarası",
    booking_passengers: "Yolcular",
    booking_adults: "Yetişkinler",
    booking_children: "Çocuklar",
    booking_child_seats: "Çocuk Koltukları",
    booking_luggage: "Bagaj",
    booking_comments: "Yorumlar",
    booking_submit: "Transfer Talep Et",
    booking_login_required: "Transfer rezervasyonu için giriş yapın",

    dashboard_title: "Transferlerim",
    dashboard_subtitle: "Rezervasyonlarınızı yönetin ve teklifleri karşılaştırın",
    dashboard_total: "Toplam Talepler",
    dashboard_with_offers: "Teklifli",
    dashboard_booked: "Rezerve Edildi",
    dashboard_login_required: "Giriş Gerekli",
    dashboard_login_desc: "Transferlerinizi görmek için giriş yapın",
    dashboard_login_btn: "Giriş Yap",
    dashboard_no_transfers: "Henüz Transfer Yok",
    dashboard_no_transfers_desc: "Ana sayfadan ilk transferinizi rezerve edin",
    dashboard_offers: "Teklifler",
    dashboard_offers_available: "Mevcut teklifler",
    dashboard_booked_driver: "Rezerve Edilen Sürücü",
    dashboard_trips: "yolculuk",
    // auto-translated fallback, needs human review
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "Kart",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "Ödendi ve Rezerve Edildi",
    dashboard_paid: "Ödendi",
    dashboard_status_open: "Açık",
    dashboard_status_bidding: "Teklifler mevcut",
    dashboard_status_booked: "Rezerve Edildi",
    dashboard_status_cancelled: "İptal Edildi",
    dashboard_completed: "Tamamlandı",

    rating_title: "Sürücü Değerlendirmesi",
    rating_punctuality: "Dakiklik",
    rating_cleanliness: "Temizlik",
    rating_friendliness: "Samimiyet",
    rating_driving_style: "Sürüş Tarzı",
    rating_comment: "Yorum (isteğe bağlı)",
    rating_submit: "Değerlendirme Gönder",
    rating_thank_you: "Teşekkürler!",
    rating_submitted: "Değerlendirmeniz başarıyla gönderildi.",
    rating_overall: "Genel Değerlendirme",
    rating_reviews: "Müşteri Yorumları",

    admin_title: "Yönetici Paneli",
    admin_overview: "Genel Bakış",
    admin_pending: "Onaylar",
    admin_drivers: "Sürücüler",
    admin_companies: "Şirketler",
    admin_transfers: "Transferler",
    admin_payments: "Ödemeler",
    admin_users: "Kullanıcılar",
    admin_approve: "Onayla",
    admin_reject: "Reddet",
    admin_block: "Engelle",
    admin_unblock: "Engeli Kaldır",
    admin_documents: "Belgeler",
    admin_export: "Dışa Aktar",
    admin_revenue: "Gelir",
    admin_active: "Aktif",
    admin_blocked: "Engellendi",
    admin_search: "Ara...",

    profile_driver: "Sürücü Profili",
    profile_company: "Şirket Profili",
    profile_member_since: "Üyelik tarihi",
    profile_trips: "yolculuk",
    profile_fleet: "Araç Filosu",

    payment_processing: "Ödeme işleniyor...",
    payment_success: "Ödeme başarılı! Rezervasyonunuz onaylandı.",
    payment_cancelled: "Ödeme iptal edildi. Tekrar deneyebilirsiniz.",
    payment_error: "Ödeme durumu doğrulanamadı.",
    payment_paypal_processing: "PayPal ödemesi işleniyor...",
    payment_paypal_success: "PayPal ödemesi başarılı! Rezervasyonunuz onaylandı.",
    payment_paypal_error: "PayPal ödeme onayında hata.",

    driver_title: "Sürücü Portalı",
    driver_new: "Yeni",
    driver_my_offers: "Tekliflerim",
    driver_offer_price: "Teklif Ver",
    driver_requests: "yeni talepler",
    driver_active_offers: "aktif teklifler",
    driver_bookings: "rezervasyonlar",
    driver_search: "Ara...",

    common_back: "Geri",
    common_home: "Ana Sayfa",
    common_loading: "Yükleniyor...",
    common_error: "Hata",
    common_save: "Kaydet",
    common_cancel: "İptal",
    common_delete: "Sil",
    common_edit: "Düzenle",
    common_add: "Ekle",
    common_close: "Kapat",
    common_confirm: "Onayla",
    common_persons: "kişi",
    common_km: "km",
    common_min: "dk",
    common_about: "Hakkımızda",
    common_contact: "İletişim",
    common_language: "Dil",

    company_title: "Şirket Kaydı",
    company_subtitle: "Taşımacılık şirketleri için filo yönetimi",
    company_name: "Şirket Adı",
    company_contact: "İletişim Kişisi",
    company_phone: "Telefon",
    company_region: "Bölge",
    company_languages: "Diller",
    company_step_company: "Şirket",
    company_step_vehicles: "Araçlar",
    company_step_drivers: "Sürücüler",
    company_next_vehicles: "Sonraki: Araçlar",
    company_next_drivers: "Sonraki: Sürücüler",
    company_submit: "Şirketi Kaydet",
    company_add_vehicle: "Araç Ekle",
    company_add_driver: "Sürücü Ekle",
    company_success: "Şirket Kaydedildi!",
    company_success_desc: "Şirketiniz ekibimiz tarafından incelenecektir.",
    company_summary: "Özet",
    company_vehicles_count: "Araçlar",
    company_drivers_count: "Sürücüler",

    footer_rights: "Tüm hakları saklıdır",
    footer_imprint: "Yasal Bilgi",
    footer_privacy: "Gizlilik",
    footer_terms: "Şartlar",

    landing_bullet1: "Ekonomik fiyatlara premium araçlar",
    landing_bullet2: "Sürücü tekliflerini anında karşılaştırın",
    landing_bullet3: "Kart, PayPal ve daha fazlasıyla güvenle ödeyin",
    landing_tab_transfer: "Transfer",
    landing_tab_hourly: "Saatlik",
    landing_continue: "Devam",
    landing_vehicles_subtitle: "Ekonomiden Lükse - mükemmel yolculuğu bulun",
    landing_easy_payment: "Kolay Ödeme",
    landing_easy_payment_desc: "Visa, Mastercard, PayPal, Twint ve daha fazlası",
    landing_hourly_rental: "Saatlik Kiralama",

    driver_portal: "Sürücü Portalı",
    driver_tab_new: "Yeni",
    driver_tab_vehicles: "Araçlar",
    driver_tab_profile: "Profilim",
    driver_tab_with_offers: "Tekliflerimle",
    driver_tab_bookings: "Rezervasyonlar",
    driver_sort_created: "Oluşturulma tarihi",
    driver_filter: "Filtre",
    driver_search_placeholder: "Ara...",
    driver_col_id: "#",
    driver_col_ride_date: "Yolculuk tarihi",
    driver_col_type: "Tür",
    driver_col_distance: "Mesafe",
    driver_col_from: "Nereden",
    driver_col_to: "Nereye",
    driver_col_passengers: "Yolcular",
    driver_col_transport: "Ulaşım",
    driver_col_your_offer: "Teklifiniz",
    driver_offered: "Teklif verildi",
    driver_offer_price_btn: "Fiyat teklif et",
    driver_no_requests: "Mevcut talep yok",
    driver_no_bookings: "Henüz rezervasyon yok",
    driver_new_requests: "yeni talepler",
    driver_active_offers_count: "aktif teklifler",
    driver_bookings_count: "rezervasyonlar",
    driver_created: "oluşturuldu",
    driver_return: "Dönüş",
    driver_tbd: "belirlenecek",
    driver_submit_offer: "Fiyat teklif et",
    driver_make_offer_title: "Teklif Ver",
    driver_make_offer_desc: "Bu yolculuk için fiyatınızı belirleyin",
    driver_your_price: "Fiyatınız (EUR)",
    driver_notes_label: "Notlar (isteğe bağlı)",
    driver_notes_placeholder: "ör. Su şişesi dahil, çocuk koltuğu mevcut...",
    driver_price_placeholder: "ör. 45",
    driver_price_suggestion: "Fiyat Önerisi",
    driver_price_recommended: "önerilen",
    driver_price_range: "Aralık",
    driver_cancel: "İptal",
    driver_login_required: "Giriş Gerekli",
    driver_login_desc: "Sürücü paneline erişmek için giriş yapın.",
    driver_login_btn: "Giriş Yap",
    driver_no_profile: "Sürücü Profili Yok",
    driver_no_profile_desc: "Önce sürücü olarak kaydolmanız gerekiyor.",
    driver_register_btn: "Sürücü Olarak Kaydol",
    driver_pending_title: "Başvuru İnceleniyor",
    driver_pending_desc: "Sürücü başvurunuz inceleniyor. Lütfen bekleyin.",
    driver_rejected_title: "Başvuru Reddedildi",
    driver_rejected_desc: "Maalesef başvurunuz reddedildi.",
    driver_complete_btn: "Tamamlandı",
    driver_complete_confirm: "Bu yolculuğu tamamlandı olarak işaretle? Müşteriye değerlendirme e-postası gönderilecek.",
    driver_complete_success: "Yolculuk tamamlandı! Müşteri değerlendirme için e-posta ile davet edildi.",
    driver_offer_success: "Teklif başarıyla gönderildi!",
    driver_offer_invalid_price: "Lütfen geçerli bir fiyat girin",
    driver_status_completed: "Tamamlandı",
    driver_status_booked: "Rezerve Edildi",
    driver_docs_missing_alert: "Devam etmeden önce tüm gerekli belgeleri yükleyin.",
    driver_docs_title: "Belge Yükle",
    driver_docs_subtitle: "Tüm gerekli belgeleri yükleyin",
    driver_docs_selfie: "Ehliyetle Selfie",
    driver_docs_registration: "Araç Ruhsatı",
    driver_docs_vehicle_photo: "Araç Fotoğrafı",
    driver_docs_insurance: "Sigorta Belgesi",
    driver_docs_license: "Taşımacılık Lisansı (isteğe bağlı)",
    driver_docs_required: "Zorunlu",
    driver_docs_optional: "İsteğe Bağlı",
    driver_docs_uploaded: "Yüklendi",
    driver_docs_camera: "Kamera",
    driver_docs_upload: "Yükle",
    driver_docs_complete_btn: "Tamamla ve Devam Et",
    driver_docs_btn: "Belgeler",
    driver_docs_incomplete: "Belgeler eksik",
    driver_docs_all_complete: "Tüm belgeler yüklendi",
    driver_terms_accept_text: "Kabul ediyorum",
    driver_terms_link: "Sürücü Şartları ve Koşulları",
    driver_terms_binding_text: "Teklifim bağlayıcıdır. Müşteri rezervasyon yapıp ödeme yaptığında, transferi kararlaştırılan zaman ve fiyatta gerçekleştirmeyi taahhüt ediyorum.",

    profile_settings: "Profil Ayarları",
    profile_edit: "Profili Düzenle",
    profile_change_password: "Şifre Değiştir",
    profile_logout: "Çıkış Yap",
    profile_name: "Ad",
    profile_email: "E-posta",
    profile_phone: "Telefon",
    profile_save: "Kaydet",
    profile_cancel: "İptal",
    profile_current_password: "Mevcut Şifre",
    profile_new_password: "Yeni Şifre",
    profile_confirm_password: "Şifreyi Onayla",
    profile_password_mismatch: "Şifreler eşleşmiyor",
    profile_password_changed: "Şifre başarıyla değiştirildi",
    profile_updated: "Profil başarıyla güncellendi",
    profile_reapproval_warning: "Ad, e-posta veya araç bilgilerini değiştirmek yeniden onay gerektirir.",
    profile_reapproval_triggered: "Hesabınızın yönetici tarafından yeniden onaylanması gerekiyor.",
    profile_vehicle_info: "Araç Bilgileri",
    profile_vehicle_make: "Marka",
    profile_vehicle_model: "Model",
    profile_vehicle_year: "Yıl",
    profile_vehicle_color: "Renk",
    profile_vehicle_plate: "Plaka",
    profile_vehicle_type: "Araç Tipi",
    profile_vehicle_passengers: "Yolcular",
    profile_vehicle_luggage: "Bagaj",
  },

  no: {
    nav_for_drivers: "For Sjåfører",
    nav_for_companies: "For Bedrifter",
    nav_driver_dashboard: "Sjåførpanel",
    nav_my_transfers: "Mine Transfers",
    nav_admin: "Admin",
    nav_login: "Logg Inn",
    nav_logout: "Logg Ut",

    auth_welcome: "Velkommen tilbake",
    auth_register_title: "Opprett Konto",
    auth_login_subtitle: "Logg inn for å administrere transferene dine",
    auth_register_subtitle: "Opprett en konto for din transfer",
    auth_name: "Fullt Navn",
    auth_email: "E-postadresse",
    auth_password: "Passord",
    auth_phone: "Telefonnummer",
    auth_login_btn: "Logg Inn",
    auth_register_btn: "Opprett Konto",
    auth_switch_to_register: "Ingen konto? Registrer deg",
    auth_switch_to_login: "Har du konto? Logg Inn",
    auth_fill_all: "Vennligst fyll ut alle obligatoriske felt",
    auth_invalid: "Ugyldig e-post eller passord",

    landing_hero_title: "Flyplasstransfer til Beste Pris",
    landing_hero_subtitle: "Sammenlign tilbud fra verifiserte sjåfører og bestill din transfer på noen minutter",
    landing_from: "Fra hvor?",
    landing_to: "Til hvor?",
    landing_search: "Søk Transfer",
    landing_how_it_works: "Slik Fungerer Det",
    landing_step1_title: "Angi Rute",
    landing_step1_desc: "Angi hente- og avleveringssted",
    landing_step2_title: "Sammenlign Tilbud",
    landing_step2_desc: "Motta tilbud fra sjåfører",
    landing_step3_title: "Bestill & Betal",
    landing_step3_desc: "Velg det beste tilbudet",
    landing_why_title: "Hvorfor 366Transfer?",
    landing_best_price: "Beste Pris",
    landing_best_price_desc: "Sammenlign tilbud og spar",
    landing_safe: "Trygt & Pålitelig",
    landing_safe_desc: "Verifiserte sjåfører og kjøretøy",
    landing_support: "Støtte Døgnet Rundt",
    landing_support_desc: "Vi er alltid her for deg",
    landing_driver_cta_title: "Bli Sjåfør hos 366Transfer",
    landing_driver_cta_desc: "Tjen penger med flyplasstransfer",
    landing_driver_cta_btn: "Registrer som Sjåfør",
    landing_vehicles: "Våre Kjøretøyklasser",

    booking_title: "Bestill Transfer",
    booking_vehicle: "Kjøretøyklasse",
    booking_date: "Dato",
    booking_time: "Tid",
    booking_flight: "Flightnummer",
    booking_passengers: "Passasjerer",
    booking_adults: "Voksne",
    booking_children: "Barn",
    booking_child_seats: "Barneseter",
    booking_luggage: "Bagasje",
    booking_comments: "Kommentarer",
    booking_submit: "Be om Transfer",
    booking_login_required: "Logg inn for å bestille en transfer",

    dashboard_title: "Mine Transfers",
    dashboard_subtitle: "Administrer dine bestillinger og sammenlign tilbud",
    dashboard_total: "Totale Forespørsler",
    dashboard_with_offers: "Med Tilbud",
    dashboard_booked: "Bestilt",
    dashboard_login_required: "Innlogging Påkrevd",
    dashboard_login_desc: "Logg inn for å se dine transfers",
    dashboard_login_btn: "Logg Inn",
    dashboard_no_transfers: "Ingen Transfers",
    dashboard_no_transfers_desc: "Bestill din første transfer fra forsiden",
    dashboard_offers: "Tilbud",
    dashboard_offers_available: "Tilbud tilgjengelige",
    dashboard_booked_driver: "Bestilt Sjåfør",
    dashboard_trips: "turer",
    // auto-translated fallback, needs human review
    dashboard_offer_anonymous_driver: "Verified Driver",
    dashboard_offer_privacy_hint: "Full contact details (name, email, phone) will be unlocked after payment confirmation.",
    trust_ssl: "SSL Encrypted",
    trust_verified: "Verified Drivers",
    trust_escrow: "Escrow Protection",
    trust_cancel: "24h Free Cancellation",
    trust_price_details: "Show price details",
    trust_price_driver: "Driver offer",
    trust_price_fee: "366transfer service fee (15%)",
    trust_price_total: "Total",
    trust_escrow_note: "Driver is paid only after your safe arrival.",
    trust_cancellation_full: "Free cancellation up to 24h before pickup – 100% money-back guarantee.",
    trust_escrow_payment: "Secure payment to 366transfer. Your driver is paid by us after your safe arrival.",
    trust_exit_title: "Any questions about your booking?",
    trust_exit_subtitle: "We\'ll help you personally – no purchase pressure.",
    trust_exit_whatsapp: "Contact WhatsApp support",
    trust_exit_back: "Back to offer",
    dashboard_pay_card: "Kort",
    dashboard_pay_paypal: "PayPal",
    dashboard_paid_booked: "Betalt & Bestilt",
    dashboard_paid: "Betalt",
    dashboard_status_open: "Åpen",
    dashboard_status_bidding: "Tilbud tilgjengelige",
    dashboard_status_booked: "Bestilt",
    dashboard_status_cancelled: "Avbestilt",
    dashboard_completed: "Fullført",

    rating_title: "Sjåførvurdering",
    rating_punctuality: "Punktlighet",
    rating_cleanliness: "Renslighet",
    rating_friendliness: "Vennlighet",
    rating_driving_style: "Kjørestil",
    rating_comment: "Kommentar (valgfritt)",
    rating_submit: "Send Vurdering",
    rating_thank_you: "Takk!",
    rating_submitted: "Din vurdering er sendt.",
    rating_overall: "Samlet Vurdering",
    rating_reviews: "Kundevurderinger",

    admin_title: "Adminpanel",
    admin_overview: "Oversikt",
    admin_pending: "Godkjenninger",
    admin_drivers: "Sjåfører",
    admin_companies: "Bedrifter",
    admin_transfers: "Transfers",
    admin_payments: "Betalinger",
    admin_users: "Brukere",
    admin_approve: "Godkjenn",
    admin_reject: "Avvis",
    admin_block: "Blokker",
    admin_unblock: "Opphev blokkering",
    admin_documents: "Dokumenter",
    admin_export: "Eksporter",
    admin_revenue: "Inntekter",
    admin_active: "Aktiv",
    admin_blocked: "Blokkert",
    admin_search: "Søk...",

    profile_driver: "Sjåførprofil",
    profile_company: "Bedriftsprofil",
    profile_member_since: "Medlem siden",
    profile_trips: "turer",
    profile_fleet: "Kjøretøyflåte",

    payment_processing: "Betaling behandles...",
    payment_success: "Betaling vellykket! Din bestilling er bekreftet.",
    payment_cancelled: "Betaling avbrutt. Du kan prøve igjen.",
    payment_error: "Kunne ikke verifisere betalingsstatus.",
    payment_paypal_processing: "PayPal-betaling behandles...",
    payment_paypal_success: "PayPal-betaling vellykket! Din bestilling er bekreftet.",
    payment_paypal_error: "Feil ved PayPal-betalingsbekreftelse.",

    driver_title: "Sjåførportal",
    driver_new: "Ny",
    driver_my_offers: "Mine Tilbud",
    driver_offer_price: "Gi Tilbud",
    driver_requests: "nye forespørsler",
    driver_active_offers: "aktive tilbud",
    driver_bookings: "bestillinger",
    driver_search: "Søk...",

    common_back: "Tilbake",
    common_home: "Hjem",
    common_loading: "Laster...",
    common_error: "Feil",
    common_save: "Lagre",
    common_cancel: "Avbryt",
    common_delete: "Slett",
    common_edit: "Rediger",
    common_add: "Legg til",
    common_close: "Lukk",
    common_confirm: "Bekreft",
    common_persons: "pers.",
    common_km: "km",
    common_min: "min",
    common_about: "Om Oss",
    common_contact: "Kontakt",
    common_language: "Språk",

    company_title: "Registrer Bedrift",
    company_subtitle: "Flåtestyring for transportselskaper",
    company_name: "Bedriftsnavn",
    company_contact: "Kontaktperson",
    company_phone: "Telefon",
    company_region: "Region",
    company_languages: "Språk",
    company_step_company: "Bedrift",
    company_step_vehicles: "Kjøretøy",
    company_step_drivers: "Sjåfører",
    company_next_vehicles: "Neste: Kjøretøy",
    company_next_drivers: "Neste: Sjåfører",
    company_submit: "Registrer Bedrift",
    company_add_vehicle: "Legg til Kjøretøy",
    company_add_driver: "Legg til Sjåfør",
    company_success: "Bedrift Registrert!",
    company_success_desc: "Bedriften din vil bli gjennomgått av vårt team.",
    company_summary: "Sammendrag",
    company_vehicles_count: "Kjøretøy",
    company_drivers_count: "Sjåfører",

    footer_rights: "Alle rettigheter forbeholdt",
    footer_imprint: "Impressum",
    footer_privacy: "Personvern",
    footer_terms: "Vilkår",

    landing_bullet1: "Premiumkjøretøy til økonomiske priser",
    landing_bullet2: "Sammenlign sjåførtilbud umiddelbart",
    landing_bullet3: "Betal trygt med kort, PayPal og mer",
    landing_tab_transfer: "Transfer",
    landing_tab_hourly: "Per Time",
    landing_continue: "Fortsett",
    landing_vehicles_subtitle: "Fra Økonomi til Luksus - finn den perfekte turen",
    landing_easy_payment: "Enkel Betaling",
    landing_easy_payment_desc: "Visa, Mastercard, PayPal, Twint og mer",
    landing_hourly_rental: "Timeutleie",

    driver_portal: "Sjåførportal",
    driver_tab_new: "Ny",
    driver_tab_vehicles: "Fordon",
    driver_tab_profile: "Min profil",
    driver_tab_with_offers: "Med mine tilbud",
    driver_tab_bookings: "Bestillinger",
    driver_sort_created: "Opprettet",
    driver_filter: "Filter",
    driver_search_placeholder: "Søk...",
    driver_col_id: "#",
    driver_col_ride_date: "Turdato",
    driver_col_type: "Type",
    driver_col_distance: "Avstand",
    driver_col_from: "Fra",
    driver_col_to: "Til",
    driver_col_passengers: "Passasjerer",
    driver_col_transport: "Transport",
    driver_col_your_offer: "Ditt tilbud",
    driver_offered: "Tilbudt",
    driver_offer_price_btn: "Tilby pris",
    driver_no_requests: "Ingen forespørsler tilgjengelige",
    driver_no_bookings: "Ingen bestillinger ennå",
    driver_new_requests: "nye forespørsler",
    driver_active_offers_count: "aktive tilbud",
    driver_bookings_count: "bestillinger",
    driver_created: "opprettet",
    driver_return: "Retur",
    driver_tbd: "ikke bestemt",
    driver_submit_offer: "Tilby pris",
    driver_make_offer_title: "Gi et Tilbud",
    driver_make_offer_desc: "Sett din pris for denne turen",
    driver_your_price: "Din Pris (EUR)",
    driver_notes_label: "Notater (valgfritt)",
    driver_notes_placeholder: "f.eks. Vannflaske inkludert, barnesete tilgjengelig...",
    driver_price_placeholder: "f.eks. 45",
    driver_price_suggestion: "Prisforslag",
    driver_price_recommended: "anbefalt",
    driver_price_range: "Område",
    driver_cancel: "Avbryt",
    driver_login_required: "Innlogging Påkrevd",
    driver_login_desc: "Logg inn for å åpne sjåførpanelet.",
    driver_login_btn: "Logg Inn",
    driver_no_profile: "Ingen Sjåførprofil",
    driver_no_profile_desc: "Du må registrere deg som sjåfør først.",
    driver_register_btn: "Registrer som Sjåfør",
    driver_pending_title: "Søknad Under Behandling",
    driver_pending_desc: "Din sjåførsøknad blir behandlet. Vennligst vent.",
    driver_rejected_title: "Søknad Avvist",
    driver_rejected_desc: "Dessverre ble søknaden din avvist.",
    driver_complete_btn: "Fullført",
    driver_complete_confirm: "Markere denne turen som fullført? Kunden mottar en vurderings-e-post.",
    driver_complete_success: "Tur fullført! Kunden ble invitert til å vurdere via e-post.",
    driver_offer_success: "Tilbud sendt!",
    driver_offer_invalid_price: "Angi en gyldig pris",
    driver_status_completed: "Fullført",
    driver_status_booked: "Bestilt",
    driver_docs_missing_alert: "Last opp alle nødvendige dokumenter før du fortsetter.",
    driver_docs_title: "Last opp Dokumenter",
    driver_docs_subtitle: "Last opp alle nødvendige dokumenter",
    driver_docs_selfie: "Selfie med Førerkort",
    driver_docs_registration: "Kjøretøyregistrering",
    driver_docs_vehicle_photo: "Kjøretøybilde",
    driver_docs_insurance: "Forsikringsbevis",
    driver_docs_license: "Transportlisens (valgfritt)",
    driver_docs_required: "Obligatorisk",
    driver_docs_optional: "Valgfritt",
    driver_docs_uploaded: "Lastet opp",
    driver_docs_camera: "Kamera",
    driver_docs_upload: "Last opp",
    driver_docs_complete_btn: "Ferdig & Fortsett",
    driver_docs_btn: "Dokumenter",
    driver_docs_incomplete: "Dokumenter ufullstendige",
    driver_docs_all_complete: "Alle dokumenter lastet opp",
    driver_terms_accept_text: "Jeg godtar",
    driver_terms_link: "Sjåførens Vilkår og Betingelser",
    driver_terms_binding_text: "Mitt tilbud er bindende. Jeg forplikter meg til å utføre transporten til avtalt tid og pris når kunden bestiller og betaler.",

    profile_settings: "Profilinnstillinger",
    profile_edit: "Rediger Profil",
    profile_change_password: "Endre Passord",
    profile_logout: "Logg Ut",
    profile_name: "Navn",
    profile_email: "E-post",
    profile_phone: "Telefon",
    profile_save: "Lagre",
    profile_cancel: "Avbryt",
    profile_current_password: "Nåværende Passord",
    profile_new_password: "Nytt Passord",
    profile_confirm_password: "Bekreft Passord",
    profile_password_mismatch: "Passordene stemmer ikke overens",
    profile_password_changed: "Passord endret",
    profile_updated: "Profil oppdatert",
    profile_reapproval_warning: "Endring av navn, e-post eller kjøretøydata krever ny godkjenning.",
    profile_reapproval_triggered: "Kontoen din må godkjennes på nytt av admin.",
    profile_vehicle_info: "Kjøretøyinformasjon",
    profile_vehicle_make: "Merke",
    profile_vehicle_model: "Modell",
    profile_vehicle_year: "Årsmodell",
    profile_vehicle_color: "Farge",
    profile_vehicle_plate: "Registreringsnummer",
    profile_vehicle_type: "Kjøretøytype",
    profile_vehicle_passengers: "Passasjerer",
    profile_vehicle_luggage: "Bagasje",
  },
};

export const useTranslation = (language) => {
  const t = (key) => {
    return translations[language]?.[key] || translations['de']?.[key] || key;
  };
  const isRTL = language === 'ar';
  return { t, isRTL };
};

export const LANGUAGE_OPTIONS = [
  { code: 'de', name: 'Deutsch', flag: 'DE' },
  { code: 'en', name: 'English', flag: 'EN' },
  { code: 'ar', name: 'العربية', flag: 'AR' },
  { code: 'ru', name: 'Русский', flag: 'RU' },
  { code: 'it', name: 'Italiano', flag: 'IT' },
  { code: 'fr', name: 'Français', flag: 'FR' },
  { code: 'zh', name: '中文', flag: 'ZH' },
  { code: 'pt', name: 'Português', flag: 'PT' },
  { code: 'nl', name: 'Nederlands', flag: 'NL' },
  { code: 'es', name: 'Español', flag: 'ES' },
  { code: 'sv', name: 'Svenska', flag: 'SV' },
  { code: 'tr', name: 'Türkçe', flag: 'TR' },
  { code: 'no', name: 'Norsk', flag: 'NO' },
];

export default translations;
